import parse, { Node } from 'xml-parser';
import * as THREE from "three";
import axios from 'axios';

import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {
    EmptyGroup,
    GetDis,
    getModuleMeshInfo,
    GetRadVal,
    getRoofModuleMeshes,
    GetRoundNum,
    syncDeactivateRoofForSavedDesign
} from './Common';
import {
    AdjustObstOrientation,
    ChangeObstHeight,
    ChangeObstLength,
    ChangeObstRadius,
    ChangeObstShape,
    ChangeObstSides,
    ChangeObstWidth,
    ChangeTreeDelete,
    ChangeTreeShape,
    CheckDefaultObst,
    DeleteObst,
    HideObject,
    SetTreeSize
} from './ObstructionControl';
import {crownImgArr} from '../../../../../Constants';
import {
    AddPathwayMesh,
    SetPathway,
    SetPathwayValue, syncSetbackVisibilityForDetachedBuildings,
    UpdateSetbackDepth,
} from './PathwayControl';
import {GetLatLon, GetXYZ} from './MapControl';
import {mapSize, SetTerrain} from './TerrainControl';
import {AddShadeMesh, AddShadePosArr, GenShadeOnFace, SetShadeFinalResult} from './RefreshShade';
import {GetTimeZone} from './IrradianceControl';
import {SetCloneVirObj} from './PushControls';
import {InitStep} from './StepControl';
import {
    AddIndividualMode, addModulesToAllRoofsMaxFill,
    DeleteSingleModuleOnRoof,
    GetFaceIdealAPI,
    GetFaceProdAPI, resetModuleInstances,
    SaveEdgeCount,
    SetBuildingModule,
    SetMaxFillForRoofs,
    SetModuleGraph,
    initForModulePlacement, updateModuleCount
} from './ModuleControl';
import {defaults, ft2m} from '../../../../../Constants';
import imgDefaultCrown from '../../../../../assets/img/tree-types/image-1.png';
import {SetLineSnap} from './LineControl';
import {Line2, LineGeometry, LineMaterial} from 'three-fatline';
import {CreateSunVecArr, SetSunPathGeo} from '../Sun-Vector-Path/LoadSun';
import treeGlbModel from '../../../../../assets/3D-Models/tree.glb'

import {useViewerStore} from "../../../../../store/store";
import {disposeObject, SetMeshOBB, SetWallMeshOBB} from './MeshControl';
import {roofTextureList} from '../../../../../Constants';
import {LoadingContext} from "../../../../../store/loadingMessageStore";
import {
    ACCESS_MULTIPLIERS,
    FACE_IDEAL_API,
    MODULE_GRAPH,
    SHADE_CALCULATIONS,
    siteCalculationState
} from "../../../../../services/siteCalculationState";
import sleep from "../../../../../helpers/sleep";
import {logger} from "../../../../../services/loggingService";
import {degToRad} from "three/src/math/MathUtils";
import {initPlaneRoofPoints, isGroundMount} from "./PlaneRoofControls";
import {isDesignOriginalSite, resetToDefaults} from "../../../../../helpers/storeHelpers";
import { AlertType, HideObjectType, ImageryOptions, SelectType } from '../../../../../@types/enums';
import { ToggleRoofTag } from './LabelControl';
import { Viewer } from '../Viewer-Factory/Viewer';
import { DrawRoofProps, edgeLine, FaceItem, ModuleData, NearRoadData, NodePos, Obstruction, OriginalAngle, PathwayMesh, RoofDesignData, RoofGroup, RoofMesh, RoofMeta, SavedRoofModulesLayout, XYZCoordinates } from '../../../../../@types/types';
import { BuildingDataJSON, BuildingJSON, EdgeJson, HoleJson, ObstructionJSON, TreeJson } from '../../../../../@types/jsonTypes';
import { Alert } from 'antd';

const testSize = 0.1, pillarW = 0.25;
const testGeo = new THREE.BoxGeometry(testSize, testSize, testSize);
const testMat = new THREE.MeshStandardMaterial({color: 0x00FF00});
export const testMesh = new THREE.Mesh(testGeo, testMat);
export const defaultObsW = 2.5 * ft2m;
const mapDefaultCrown = new THREE.TextureLoader().load(imgDefaultCrown);
mapDefaultCrown.wrapS = mapDefaultCrown.wrapT = THREE.RepeatWrapping;


export function LoadPlane(self: Viewer) {
    self.mapCustom = GetPlane({x: mapSize, y: mapSize});
    self.mapCustom.receiveShadow = true;
    self.mapCustom.position.y = -0.2;
    self.mapCustom.aspectRatio = 1;
    self.mapCustom.visible = false;
    self.totalGroup.add(self.mapCustom);
    initPlaneRoofPoints(self);
}

export function Obstruction_Tree_Initial_Setup(self: Viewer) {
    const obsGeo = new THREE.BoxGeometry(1, 1, 1),
        obsMat = new THREE.MeshStandardMaterial({color: 0xD3D3D3, transparent: false, opacity: 0.5}),
        obsMesh: any = new THREE.Mesh(obsGeo, obsMat), obsFrame = obsMesh.clone();

    obsMesh.position.y = 0.5;
    obsMesh.shapeNum = 1;
    SetMeshOBB(obsMesh);


    obsFrame.visible = false;
    obsFrame.material = new THREE.MeshBasicMaterial({color: 0xFF0000, wireframe: true});

    self.virObs = new THREE.Group();
    const outGroup = new THREE.Group(), inGroup = new THREE.Group();
    self.virObs.add(outGroup);
    outGroup.add(inGroup);
    inGroup.add(obsMesh, obsFrame);
    self.virObs.visible = false;




    self.virTree = GetTreeObj({x: 0, y: 0}, self.crownModel);
    SetTreeSize(self, self.virTree, {height: 8, crown_radius: 4, crown_height: 5, trunk_radius: 0.5});
    self.virTree.traverse((child: any) => {
        if (child instanceof THREE.Mesh) {
            child.material.opacity = 0.5;
            child.material.transparent = true;
        }
    });
    self.virTree.visible = false;
    let treeTransMesh: any = new THREE.Mesh(new THREE.BoxGeometry(), new THREE.MeshStandardMaterial({
        transparent: true,
        opacity: 0
    }));
    treeTransMesh.meshType = 'tree';
    self.treeTransMesh = treeTransMesh;

    const moduleGeo = new THREE.BoxGeometry(1, 0.1, 1);
    const moduleMat = new THREE.MeshStandardMaterial({color: 0x0000FF, transparent: true, opacity: 0.8});
    const moduleMesh = new THREE.Mesh(moduleGeo, moduleMat);

    //add border to module by edge geometry
    const moduleEdgeGeo = new THREE.EdgesGeometry(moduleGeo);
    const moduleEdgeMat = new THREE.LineBasicMaterial({color: 0x000000});
    const moduleEdgeMesh = new THREE.LineSegments(moduleEdgeGeo, moduleEdgeMat);
    moduleMesh.add(moduleEdgeMesh);

    SetMeshOBB(moduleMesh);

    self.virModule = new THREE.Group();
    self.virModule.add(moduleMesh);
    self.virModule.visible = false;

    self.totalGroup.add(self.virObs, self.treeTransMesh!, self.virModule);
}

export function GetPlane(size:  { x: number, y: number }, transparent=false) {
    const planeGeo = new THREE.PlaneGeometry(size.x, size.y);
    const planeMat = new THREE.MeshStandardMaterial({
        color: 0xffffff,
        side: THREE.DoubleSide,
        transparent,
        opacity: transparent ? 0 : 1
    });
    const planeMesh = new THREE.Mesh(planeGeo, planeMat);
    planeMesh.rotation.x = -Math.PI / 2;
    return planeMesh;
}

export function LoadCrownMap(self: Viewer) {
    crownImgArr.forEach(item => {
        const crownMap: any = new THREE.TextureLoader().load(item.img);
        crownMap.wrapS = crownMap.wrapT = THREE.RepeatWrapping;
        crownMap.crownKey = item.key;
        self.crownMapArr.push(crownMap);
    });
}

export function LoadTreeModel() {
    return new Promise((resolve, reject) => {
        const gltfLoader = new GLTFLoader();
        gltfLoader.load(treeGlbModel, (treeModel) => {
            resolve(treeModel);
        }, (xhr) => {
        }, (e) => {
            logger.error(e);
            reject(e);
        });
    })
}

// Create a crcle geometry for Tree Perimeter Tool
export function LoadTreePerimeter(self: Viewer) {
    const radius = 44.72; //ie: Default 150 feet
    const geometry = new THREE.CircleGeometry(radius, 50);
    const material = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.4 });
    const circle = new THREE.Mesh(geometry, material);
    circle.position.y = 2;
    circle.name = 'roofSquirrelCircle';
    circle.visible = false;
    circle.renderOrder = 1000; //render on top of everything
    material.depthTest = false;
    material.depthWrite = false;
    circle.rotateX(-Math.PI / 2);
    self.totalGroup.add(circle);
}

export function GetShapePosArr(posArr: XYZCoordinates[], pitch: number, azimuth: number, lastNode: XYZCoordinates, isRoofMesh = false) {
    const pos2DArr: NodePos[] = [], nodeArr: XYZCoordinates[] = [], node3dGroup = new THREE.Group();
    posArr.forEach(pos => {
        nodeArr.push({x:pos.x-lastNode.x, y:pos.y-lastNode.y, z:pos.z-lastNode.z});
    });
    nodeArr.forEach(node => {
        const cloneTest = testMesh.clone();
        cloneTest.position.set(node.x, node.y, node.z);
        node3dGroup.add(cloneTest);
    });

    node3dGroup.rotation.x = GetRadVal(pitch);
    node3dGroup.rotation.y = GetRadVal(azimuth);

    node3dGroup.children.forEach(nodeMesh => {
        const wPos = nodeMesh.getWorldPosition(new THREE.Vector3());
        pos2DArr.push({...wPos});
    });
    const custom2DArr = GetCustom2DArr(pos2DArr, isRoofMesh);
    return {pos2DArr: custom2DArr};
}

const maxCrookAngle = 0.02;

function GetCustom2DArr(pos2DArr: NodePos[], isRoofMesh: boolean) {
    if (!isRoofMesh) return pos2DArr;
    const length = pos2DArr.length, posLast = pos2DArr[length - 1], pos0 = pos2DArr[0], numN = length - 2, posN = pos2DArr[numN];
    if (length < 4) return pos2DArr;
    const d0X = Math.abs(pos0.x), d0Z = Math.abs(pos0.z),
          dNX = Math.abs(posN.x), dNZ = Math.abs(posN.z);
    var axisCrook: 'x' | 'z' | null = null, curNode = {...posLast}, nodeIdx = 0;

    if      (d0X < d0Z && d0X/d0Z < maxCrookAngle) axisCrook = 'x';
    else if (d0Z < d0X && d0Z/d0X < maxCrookAngle) axisCrook = 'z';
    if (!axisCrook) return pos2DArr;

    while (nodeIdx <= numN && axisCrook) {
        const axisOther = axisCrook==='x'?'z':'x',
            disAxis = Math.abs(curNode[axisCrook] - pos2DArr[nodeIdx][axisCrook]),
            disOther = Math.abs(curNode[axisOther] - pos2DArr[nodeIdx][axisOther]);
        if (disAxis > disOther || disAxis / disOther > maxCrookAngle) {axisCrook = null; break;}

        pos2DArr[nodeIdx][axisCrook] = curNode[axisCrook];
        curNode = {...pos2DArr[nodeIdx]};
        axisCrook = axisCrook==='x'?'z':'x';
        nodeIdx++;
    }
    if (axisCrook && nodeIdx === length - 1) {
        if (Math.abs(pos2DArr[numN][axisCrook]) < 0.01)
            pos2DArr[numN][axisCrook] = 0;
    } else {
        axisCrook = null; curNode = {...posLast};
        var endNodeIdx = numN;
        if      (dNX < dNZ && dNX/dNZ < maxCrookAngle) axisCrook = 'x';
        else if (dNZ < dNX && dNZ/dNX < maxCrookAngle) axisCrook = 'z';
        if (!axisCrook) return pos2DArr;

        while (endNodeIdx > nodeIdx && axisCrook) {
            const axisOther = axisCrook==='x'?'z':'x',
                disAxis = Math.abs(curNode[axisCrook] - pos2DArr[endNodeIdx][axisCrook]),
                disOther = Math.abs(curNode[axisOther] - pos2DArr[endNodeIdx][axisOther]);
            if (disAxis > disOther || disAxis / disOther > maxCrookAngle) {axisCrook = null; break;}

            pos2DArr[endNodeIdx][axisCrook] = curNode[axisCrook];
            curNode = {...pos2DArr[endNodeIdx]};
            axisCrook = axisCrook==='x'?'z':'x';
            endNodeIdx--;
        }
    }
    return pos2DArr;
}

function GetWallMesh(pos3DArr: NodePos[], houseId: string | undefined, meshArr: any[], ppInfo: { h: number, w: number }, roofFaceId: string) {

    const sceneViewer = useViewerStore.getState().sceneViewer;
    const posArr = pos3DArr.map(pos => ({...pos, y: pos.y + ppInfo.h}));
    const pos0 = posArr[0], pos1 = posArr[1], inGroup = new THREE.Group(), outGroup = new THREE.Group();
    outGroup.add(inGroup);
    const posOrder = [{...pos0, y: 0}, {...pos0}, {...pos1}, {...pos1, y: 0}], firstPos = posOrder[0];
    for (let i = 0; i < 4; i++) {
        const clonePos = testMesh.clone();
        const selPos = posOrder[i];
        clonePos.position.set(selPos.x - firstPos.x, selPos.y, selPos.z - firstPos.z);
        inGroup.add(clonePos);
    }
    const dz = pos1.z - pos0.z, dx = pos0.x - pos1.x;
    const rotY = Math.atan2(dx, dz);
    inGroup.rotation.y = rotY;
    outGroup.rotation.z = Math.PI / 2;

    const pos2DArr: NodePos[] = [];
    inGroup.children.forEach(pos => {
        const posW = pos.getWorldPosition(new THREE.Vector3());
        pos2DArr.push(posW);
    });

    const wallEditedHeight = useViewerStore.getState().wallEditedHeight;
    const wallOriginalHeight = useViewerStore.getState().wallInitialHeight;

    const deltaHeight = wallEditedHeight - wallOriginalHeight;

    const wallShape = new THREE.Shape(), firstVer = pos2DArr[0];
    wallShape.moveTo(firstVer.x, firstVer.z);
    pos2DArr.forEach(ver => {
        wallShape.lineTo(ver.x-deltaHeight, ver.z);
    });
    const extrudeSettings = {depth: 0.0001, bevelEnabled: false,};
    const wallGeo = new THREE.ExtrudeGeometry(wallShape, extrudeSettings);
    const wallMat = new THREE.MeshStandardMaterial({color: 0xCCCCCC});
    const frameMat = new THREE.MeshBasicMaterial({color: 0xFF0000, wireframe: true});

    const wallMesh: any = new THREE.Mesh(wallGeo, wallMat), wallFrame = new THREE.Mesh(wallGeo, frameMat);
    wallFrame.visible = false;
    wallMesh.roofFaceId = roofFaceId;
    wallMesh.houseId = houseId;
    wallMesh.meshType = 'roof';
    wallMesh.name = 'wallMesh' + GetIdStr(6);
    wallMesh.rotation.x = wallFrame.rotation.x = wallMesh.rotX = Math.PI / 2;
    wallMesh.castShadow = true;
    wallMesh.userData.positions = pos2DArr;
    wallMesh.userData.depth = ppInfo.w;
    wallMesh.userData.isGroundMount = sceneViewer.roofs[0].faces.find((face: FaceItem) => face.roofFaceId === roofFaceId)?.surfaceMount;


    const center = new THREE.Vector3((pos1.x + pos0.x) / 2, Math.max(pos0.y, pos1.y) / 2, (pos1.z + pos0.z) / 2);
    wallMesh.updateWorldMatrix(true, false);
    SetWallMeshOBB(wallMesh, center, firstPos);
    sceneViewer.wallMeshArr.push(wallMesh);
    meshArr.push(wallMesh);

    const wallInGroup = new THREE.Group(), wallOutGroup = new THREE.Group();
    wallInGroup.add(wallMesh, wallFrame);
    wallInGroup.rotation.z = Math.PI / -2;
    wallOutGroup.name = 'wallGroup'
    wallOutGroup.add(wallInGroup);
    wallOutGroup.rotation.y = wallMesh.rotY = -rotY;
    wallOutGroup.position.set(firstPos.x, 0, firstPos.z);
    wallMesh.worldPos = {x: firstPos.x, z: firstPos.z};
    return wallOutGroup;
}

function GetPillarMesh(pos2D: NodePos, pos3D: NodePos, azimuth: number, self: Viewer, roofFaceId: string) {
    const sceneViewer = useViewerStore.getState().sceneViewer;
    const {x, y, z} = pos2D,
        pillarGeo = new THREE.BoxGeometry(pillarW, y, pillarW),
        pillarMat = new THREE.MeshStandardMaterial({color: 0xEEEEEE}),
        pillarMesh: any = new THREE.Mesh(pillarGeo, pillarMat),
        pillarGroup = new THREE.Group();
    pillarGroup.position.set(pos3D.x , 0, pos3D.y);
    pillarGroup.rotation.y = GetRadVal(-azimuth);
    pillarMesh.roofFaceId = roofFaceId;
    pillarMesh.userData.isGroundMount = sceneViewer.roofs[0].faces.find((face: FaceItem) => face.roofFaceId === roofFaceId)?.surfaceMount;
    //Set Center and OBB
    const center = new THREE.Vector3(pos3D.x, y / 2, pos3D.y);
    pillarMesh.updateWorldMatrix(true, false);
    SetWallMeshOBB(pillarMesh, center, {x: pos3D.x - pillarW / 2, y: 0, z: pos3D.y - pillarW / 2});
    


    pillarGroup.add(pillarMesh);
    self.wallMeshArr.push(pillarMesh);
    self.meshArr.push(pillarMesh);
    pillarMesh.position.set(x, y / 2, z);
    return pillarGroup;
}

function GetPosArr(nodeArr: NodePos[], idxArr: number[]) {
     return idxArr.map(idx => ({ ...nodeArr[idx] }));
}

function GetXMLFacePosArr(lineArr: EdgeJson[], lineIdArr: string[]) {
    var posArr: NodePos[] = [], selLineArr: EdgeJson[] = [];
    lineIdArr.forEach(lineId => {
        const lineItem = lineArr.find(item => item.id === lineId);
        if (lineItem) selLineArr.push({...lineItem});
    });
    posArr.push(selLineArr[0].posArr[0], selLineArr[0].posArr[1]);
    selLineArr[0].pass = true;
    while (posArr.length < lineIdArr.length) {
        const lastPosId = posArr[posArr.length - 1].id;
        var nextLine = selLineArr.find(item => (item.posArr[0].id === lastPosId || item.posArr[1].id === lastPosId) && item.pass !== true);
        if (!nextLine) {
            if (lastPosId === posArr[0].id) posArr.pop();
            break;
        }
        nextLine.pass = true;
        const pos0 = nextLine.posArr[0], pos1 = nextLine.posArr[1];
        posArr.push(pos0.id === lastPosId ? pos1 : pos0);
    }

    const repeatArr = [], customArr: NodePos[] = [];
    for (let i = 0; i < posArr.length - 3; i++) {
        for (let j = i + 2; j < posArr.length - 1; j++) {
            if (posArr[i].id === posArr[j].id) {
                repeatArr.push({ start: i, end: j });
                break;
            }
        }
    }

    if (repeatArr.length > 0) {
        const areaArr = [], area0 = [], repeat0 = repeatArr[0];
        var maxLengthNum = -1, maxLength = -Infinity;
        for (let i = 0; i < repeatArr.length - 1; i++) {
            const repeat = repeatArr[i], area = [];
            for (let j = repeat.start; j < repeat.end; j++) {
                area.push(posArr[j]);
            }
            areaArr.push(area);
        }
        for (let i = 0; i < repeat0.start; i++) {
            area0.push(posArr[i]);
        }
        for (let i = repeat0.end; i < posArr.length; i++) {
            area0.push(posArr[i]);
        }
        areaArr.push(area0);
        areaArr.forEach((area, aIdx) => {
            var areaLength = 0;
            for (let i = 0; i < area.length - 1; i++) {
                areaLength += GetDis(area[i], area[i + 1]);
            }
            if (areaLength > maxLength) {
                maxLength = areaLength;
                maxLengthNum = aIdx;
            }
        });
        if (maxLengthNum !== -1) {
            areaArr[maxLengthNum].forEach(node => {
                customArr.push(node);
            });
        } else {
            posArr.forEach(node => {
                customArr.push(node);
            });
        }
    } else {
        posArr.forEach(node => {
            customArr.push(node);
        });
    }
    return customArr;
}

export function GetIdStr(strLength = 10) {
    const oriStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567890-=!@#$%^&*()_+';
    var idStr = '';
    for (let i = 0; i < strLength; i++) {
        idStr += oriStr[Math.floor(oriStr.length * Math.random())]
    }
    return idStr;
}

export function GetShapeOrPath(pos2DArr: NodePos[]) {
    const shapePath =  new THREE.Shape(), lastPos = pos2DArr[pos2DArr.length - 1];
    shapePath.moveTo(lastPos.x, lastPos.z);
    pos2DArr.forEach(pos => {
        shapePath.lineTo(pos.x, pos.z);
    });
    return shapePath;
}



function GetBlackLineEdge(posArr: NodePos[]) {
    const positionsArray =  posArr.map(pos => [pos.x, pos.y, pos.z]).flat();

    const edgeGeo = new LineGeometry().setPositions(positionsArray);
    const edgeMat = new LineMaterial({
        color: 0x000000,
        linewidth: 3,
        resolution: new THREE.Vector2(window.innerWidth, window.innerHeight)
    });
    edgeMat.depthWrite = true
    edgeMat.depthTest = true

    const edgeMesh = new Line2(edgeGeo, edgeMat);
    edgeMesh.userData.positions = positionsArray;
    return edgeMesh;
}

const assignRoofTagId =(face: FaceItem, roof: RoofMesh, roofMeshArr: RoofMesh[])=>{
    if(roof.flatRoof){
        if (roof.userData.roof_tag_id){
            console.log('roof.userData.roof_tag_id', roof.userData.roof_tag_id);
            return roof.userData.roof_tag_id
        } else if (face.roof_number_from_aurora !== undefined) {
            console.log('face.roof_number_from_aurora', face.roof_number_from_aurora);
            return face.roof_number_from_aurora;
        } else {
            let roofNum = 0;
            function availableRoofNum() {
                const arr = roofMeshArr.map(roof => roof.userData.roof_tag_id);
                arr.sort((a, b) => a - b);
                for (let i = 1; i <= arr[arr.length - 1]; i++) {
                  if (!arr.includes(i)) return i;
                }
                return arr[arr.length - 1] + 1;
              }
            return availableRoofNum();
        }  
    } else {
        if(face.roof_number_from_aurora===undefined) face.roof_number_from_aurora = face.roof_tag_id
        return face.roof_number_from_aurora
    }
}





export function CalcPolygonArea(posArr: NodePos[]) {
    var total = 0;
    for (var i = 0, l = posArr.length; i < l; i++) {
        const addX = posArr[i].x;
        const addY = posArr[i == posArr.length - 1 ? 0 : i + 1].z;
        const subX = posArr[i == posArr.length - 1 ? 0 : i + 1].x;
        const subY = posArr[i].z;

        total += (addX * addY * 0.5);
        total -= (subX * subY * 0.5);
    }
    return Math.abs(total);
}





export function GetHouseBound(roofGroup: RoofGroup) {
    const cloneRoof = roofGroup.clone();
    for (let i = cloneRoof.children.length - 1; i >= 0; i--) {
        const child: any = cloneRoof.children[i];
        if (child.pathName || child.userData.pathName || child.userData.flat) cloneRoof.remove(child);
    }
    const vPos = new THREE.Box3().setFromObject(cloneRoof), {max, min} = vPos;
    const vSize = {x: max.x - min.x, y: max.y - min.y, z: max.z - min.z};
    const boundR = Math.max(vSize.x, vSize.z);
    const boundGeo = new THREE.CylinderGeometry(boundR / 2, boundR / 2, 1, 32);
    const boundMat = new THREE.MeshStandardMaterial({color: 0xFF0000, transparent: true, opacity: 0.4});
    const boundMesh: any = new THREE.Mesh(boundGeo, boundMat);
    const cPos: NodePos = {x: (max.x + min.x) / 2, y: (max.y + min.y) / 2, z: (max.z + min.z) / 2};
    boundMesh.houseId = roofGroup.houseId;
    boundMesh.visible = false;
    roofGroup.disY = vSize.y;
    roofGroup.scale.y = 1 / vSize.y;

    roofGroup.sclY = 1;
    roofGroup.children.forEach((child: any) => {
        // if (child.userData.flat) return;
        (['x', 'z']  as (keyof XYZCoordinates)[]).forEach(axis => {
            child.position[axis] -= cPos[axis];
        });
    });
    boundMesh.position.set(cPos.x, 0, cPos.z);
    boundMesh.oriPos = {...boundMesh.position};
    roofGroup.position.set(cPos.x, 0, cPos.z);
    return boundMesh;
}

const crownGeo = new THREE.SphereGeometry(0.5, 32, 32),
    crwonMat = new THREE.MeshStandardMaterial({color: 0x90EE90}),
    crownDefault: any = new THREE.Mesh(crownGeo, crwonMat);
crownDefault.crownScl = {x: 1, y: 1, z: 1};

function GetTreeObj(treePos: { x: number, y: number }, crownModel: any) {
    const {x, y} = treePos, obstId = GetIdStr(), normalCrown = crownModel || crownDefault,
        crownMesh = normalCrown.clone();
    const {map, color, transparent} = crownMesh.material;
    crownMesh.material = new THREE.MeshStandardMaterial({color: 0x90EE90, map, transparent, depthWrite: true, side: 1});
    crownMesh.crownScl = {...normalCrown.crownScl};
    crownMesh.mapSrc = normalCrown.material.map;
    const treeGroup: any = new THREE.Group(),
        trunkGeo = new THREE.CylinderGeometry(1, 1, 1),
        crownColor = crownMesh.material.color,
        trunkColor = new THREE.Color(0.6 + Math.random() * 0.4, 0.2 + Math.random() * 0.2, 0),
        trunkMat = new THREE.MeshStandardMaterial({color: trunkColor}),
        trunkMesh: any = new THREE.Mesh(trunkGeo, trunkMat),
        wrapperGeo = new THREE.CylinderGeometry(1, 1, 1, 8),
        wrapperMat = new THREE.MeshStandardMaterial({color: 0xFFFFFF, transparent: false, wireframe: true}),
        wrapperMesh: any = new THREE.Mesh(wrapperGeo, wrapperMat);
    wrapperMesh.obstId = crownMesh.obstId = trunkMesh.obstId = treeGroup.obstId = obstId;
    wrapperMesh.meshType = crownMesh.meshType = trunkMesh.meshType = 'tree';
    wrapperMesh.name = 'wrapper';
    crownMesh.name = 'crown';
    trunkMesh.name = 'trunk';
    wrapperMesh.visible = false;
    wrapperMesh.treeFrame = true;
    crownMesh.oriColor = crownColor.getHex();
    trunkMesh.oriColor = trunkColor.getHex();
    treeGroup.add(crownMesh, trunkMesh, wrapperMesh);
    treeGroup.position.set(x, 0, y);
    wrapperMesh.worldPos = {x, z: y};
    return treeGroup;
}

function ModelLoadInit(self: Viewer) {
    self.setTopView(false);
    self.setAutoRotate(false);
    self.viewMode = '3d';
    self.camera.position.set(0, 100, 80);
    self.setCameraView('3d',true);
    SaveEdgeCount(self.roofs[0].edges);
    self.selTypeMeshArr = [];
    self.flagModulePathway = true;
    self.flagLineSnap = true;
    self.houseTransPos = {x: 0, z: 0};
}

function InitStateValue(self: Viewer) {
    resetToDefaults()
    self.irrCSVDateArr = null;
    self.irrCSVMainData = null;
    self.sunVecArr = null;
    self.buildingAlt = null;
    self.meshArr = [];
    self.buildingArr = [];
    self.moduleDir = 'both';
    self.wallMeshArr = []
    InitStep(self);
    ToggleRoofTag(self, false);
}

export function calculateMeshAreaInSquareFeet(mesh: any): number {
    // Ensure that the geometry is a BufferGeometry for ease of processing
    // let geometry = mesh.geometry.isBufferGeometry ? mesh.geometry : new THREE.BufferGeometry().fromGeometry(mesh.geometry);
    let geometry = mesh.geometry as THREE.BufferGeometry;

    // Check if the geometry has a defined index (for indexed BufferGeometry)
    const isIndexed = geometry.index !== null;
    const vertices = geometry.attributes.position.array;
    let totalArea = 0;

    const calculateTriangleArea = (a: THREE.Vector3, b: THREE.Vector3, c: THREE.Vector3) => {
        // Simplified area calculation for 2D triangles
        return 0.5 * Math.abs(a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - b.y));
    };

    if (geometry.index) { // Check if the geometry has a defined index (for indexed BufferGeometry)
        const indices = geometry.index.array;
        for (let i = 0; i < indices.length; i += 3) {
            const a = new THREE.Vector3().fromArray(vertices, indices[i] * 3);
            const b = new THREE.Vector3().fromArray(vertices, indices[i + 1] * 3);
            const c = new THREE.Vector3().fromArray(vertices, indices[i + 2] * 3);
            totalArea += calculateTriangleArea(a, b, c);
        }
    } else {
        for (let i = 0; i < vertices.length; i += 9) {
            const a = new THREE.Vector3(vertices[i], vertices[i + 1], 0);
            const b = new THREE.Vector3(vertices[i + 3], vertices[i + 4], 0);
            const c = new THREE.Vector3(vertices[i + 6], vertices[i + 7], 0);
            totalArea += calculateTriangleArea(a, b, c);
        }
    }

    // Convert to square feet if needed, assuming 1 unit = 1 foot
    return totalArea * 5.38156348687479
}

async function LoadTree(self: Viewer) {
    let object: any = await LoadTreeModel();

    object = object.scene.children[0];
    object.material.transparent = true;
    object.material.map = mapDefaultCrown;
    object.material.side = 0;
    const vPos = new THREE.Box3().setFromObject(object), vSize = vPos.getSize(new THREE.Vector3());
    object.crownScl = {x: 1 / vSize.x, y: 1 / vSize.y, z: 1 / vSize.z};
    self.crownModel = object;
    self.virTree = GetTreeObj({x: 0, y: 0}, object);
    self.virTree.visible = false;
    SetTreeSize(self, self.virTree, {height: 8, crown_radius: 4, crown_height: 5, trunk_radius: 0.4});
    self.totalGroup.add(self.virTree);

    LoadCrownMap(self);
}



function correctAttachedRoofStructures(data: any) {
    data = parseJson(data);
    const roofs: BuildingJSON[] = data.roofs;

    const mainRoof = roofs[0];

    const distanceThreshold = 10;

    const mainCentroid = computeCentroidNew(mainRoof.nodes);

    const roofsToMerge = [];


    for (let i = 1; i < roofs.length; i++) {
        const roof = roofs[i];
        const centroid = computeCentroidNew(roof.nodes);
        const distance = computeDistance(mainCentroid, centroid);

        if (distance < distanceThreshold) {
            roofsToMerge.push(i);
        }
    }

    roofsToMerge.sort((a, b) => b - a);
    roofsToMerge.forEach((roofIndex) => {
        const roof = roofs[roofIndex];
        const nodeOffset = mainRoof.nodes.length;

        mainRoof.nodes = mainRoof.nodes.concat(roof.nodes);

        roof.faces.forEach((face) => {
            face.shell = face.shell?.map((index) => index + nodeOffset);
            face.holes = face.holes.map(hole =>
                hole.map(index => index + nodeOffset)
            );
            mainRoof.faces.push(face);
        });

        roof.edges.forEach((edge: EdgeJson) => {
            edge.nodes = edge.nodes?.map((index) => index + nodeOffset);
            mainRoof.edges.push(edge);
        });

        roofs.splice(roofIndex, 1);
    });

    return data;

}

export function computeCentroid(nodes: NodePos[]) {
    const centroid = nodes.reduce(
        (acc, node) => {
            acc.X! += node.X ?? 0;
            acc.Y! += node.Y ?? 0;
            acc.Z! += node.Z ?? 0;
            return acc;
        },
        { X: 0, Y: 0, Z: 0 }
    );
    const n = nodes.length;
    centroid.X! /= n;
    centroid.Y! /= n;
    centroid.Z! /= n;
    return centroid;
}

function computeDistance(pointA: NodePos, pointB: NodePos) {
    const dx = pointA.X! - pointB.X!;
    const dy = pointA.Y! - pointB.Y!;
    const dz = pointA.Z! - pointB.Z!;
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}


function centerRoof(data: any) {
    data = parseJson(data);
    if (!data.roofs || !Array.isArray(data.roofs) || data.roofs.length === 0) {
        console.warn('No roofs found to center.');
        return data;
    }

    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;

    data.roofs.forEach((roof: BuildingJSON) => {
        roof.nodes.forEach((node) => {
            if (node.X && node.X < minX) minX = node.X;
            if (node.X && node.X > maxX) maxX = node.X;
            if (node.Y && node.Y < minY) minY = node.Y;
            if (node.Y && node.Y > maxY) maxY = node.Y;
        });
    });

    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;


    data.roofs.forEach((roof: BuildingJSON) => {
        roof.nodes.forEach((node) => {
            if (node.X) node.X -= centerX;
            if (node.Y) node.Y -= centerY;
        });
    });

    if (data.obstructions && Array.isArray(data.obstructions)) {
        data.obstructions.forEach((obs: ObstructionJSON) => {
            if (typeof obs.x === 'number' && typeof obs.y === 'number') {
                obs.x -= centerX;
                obs.y -= centerY;
            }
        });
    }

    if(data.trees && Array.isArray(data.trees)){
        data.trees.forEach((tree: TreeJson) => {
            if (typeof tree.x === 'number' && typeof tree.y === 'number') {
                tree.x -= centerX;
                tree.y -= centerY;
            }
        });
    }

    return data;
}

function parseJson(data: any) {
    let attempts = 0;
    const maxAttempts = 3;

    try {
        while (typeof data === 'string' && attempts < maxAttempts) {
            data = JSON.parse(data);
            attempts++;
        }
    } catch (e) {
        console.error('Failed to parse JSON:', e);
        return;
    }

    if (typeof data === 'string') {
        console.warn('JSON parsing stopped after 3 attempts, still a string:', data);
        return;
    }
    return data;
}


export async function LoadModelJson(self: Viewer, json: any, modelType?: string, isUserUploadedMannually = false) {
    let testRoofJson = parseJson(json);
    if (testRoofJson === null || testRoofJson === "" || !testRoofJson) return;


    testRoofJson = correctAttachedRoofStructures(testRoofJson);




    //DEBUG : Log JSON file
    // console.log("Corrected Roof Structures JSON:", testRoofJson);

    const sceneViewer = useViewerStore.getState().sceneViewer;
    if (sceneViewer.scene.children.length > 0) {
        sceneViewer.clearScene();
    }

    resetModuleInstances(self);
    const isGlb = modelType === 'glb';

    const loadingContext = new LoadingContext();
    loadingContext.setDefaultTitle('Drawing Site...');
    loadingContext.setMessage({ message: 'Drawing Site Objects from Aurora...' });

    useViewerStore.setState({sitejson: JSON.stringify(testRoofJson)})
    sessionStorage.setItem("dataSourceOrigin", "aurora");

    siteCalculationState.reset();

    try {
        loadingContext.setMessage({ message: 'Getting Tree Model...' });
        await LoadTree(self);

        self.designFormat  = 'JSON';
        sessionStorage.setItem("dataSourceOrigin", "aurora");

        loadingContext.setMessage({ message: 'Parsing Data...' });

        const {
            buildings,
            roofs,
            trees,
            obstructions,
            origin,
            sunInfo,
            irrCSVMainData,
            irradianceMonth,
            localAngIdealArr,
            localFacePtHashArr,
            localAngMultiplierInfo,
            weatherStationName,
            mapPosition,
            mapProperties,
        } = testRoofJson, {latitude, longitude} = origin;


        const facesRef: FaceItem[] = roofs[0].faces;
        if (isUserUploadedMannually) {
            let allFacesHasRoofNumber = true;
            facesRef.forEach((face) => {
                if (!face.roof_number) {
                    allFacesHasRoofNumber = false;
                }
            });

            if (!allFacesHasRoofNumber) {
                EmptyGroup(self.totalGroup);
                self.viewerAlert({
                    show: true,
                    title: "Error in Aurora JSON data",
                    message: "Roof number attribute is missing in the Aurora JSON data, please validate the data and try again.",
                    messageType: AlertType.error,
                    isModal: true
                });
                return;
            }

        }


        const activeModuleName = roofs[0].faces.flatMap((f: FaceItem) => f.moduleArr?.map(m => m.selSize.text) ?? [])[0];
        if (activeModuleName) {
            const moduleList = useViewerStore.getState().moduleList;
            const activeModule = moduleList.find(m => m.text === activeModuleName);
            if (activeModule) {
                useViewerStore.setState({activeModule: activeModule});
            }
        }
        InitStateValue(self);
        SetTerrain(self, origin);

        self.mapCoordinates = origin;
        self.weatherStationName = weatherStationName;
        useViewerStore.setState({savedLocationCoordinates: origin});

        if (isGlb) {
            setDetachedStructuresInStoreFromSavedBuildingData(buildings)
            self.sunInfo = sunInfo;
            self.sunVecArr = CreateSunVecArr(sunInfo);
            self.irrCSVMainData = irrCSVMainData;

            useViewerStore.setState({
                savedRoofWiseIdealMultiplier: localAngIdealArr,
                savedRoofWiseAccessMultiplierDataArray: localFacePtHashArr,
                savedAccessMultipliersForSolarRoofs: localAngMultiplierInfo,
            });
        } else {
            self.sunInfo.lat = latitude;
            self.sunInfo.lon = longitude;
            self.sunInfo.utcOffset = undefined;
            self.sunInfo.timezone = undefined;
        }

        useViewerStore.setState({
            imageryType : mapProperties?.imageryType ?? ImageryOptions.DEFAULT,
            customImageScale: mapProperties?.scale ?? 0.7,
            customImageRotation: mapProperties?.rotation ?? 0,
        });

        if(mapProperties?.imageryType === 'custom') {
            self.viewerAlert({ //Display alert that site contains custom map imagery
                show: true,
                title: "Custom Imagery Detected",
                message: "This site design is based on a manually imported map image. The image was not sourced from a standard provider such as Google Maps, Nearmaps, or Mapbox.",
                messageType: AlertType.info,
                isModal: false
            });
        }
        self.fetchMapImageAndLoadOnPlane(mapProperties?.imageryType ?? ImageryOptions.DEFAULT); // Fetch and load the predefined imagery or Nearmap by default if type not defined
        roofs.forEach((building: BuildingJSON) => {
            building.roofSize = 0;
            building.faces.forEach(face => {
                building.roofSize += face.sq_footage || 0;
            });
        });

        roofs.forEach((roof: BuildingJSON, idx: number) => {
            const {faces} = roof;
            const buildingName = idx + 1
            faces.forEach((face) => {
                if (!face.buildingName) {
                    //building name should be reverse order
                    face.buildingName = buildingName;
                }
            });
        });

        roofs.sort((a: BuildingJSON, b: BuildingJSON) => b.roofSize! - a.roofSize!);

        var minVal = Infinity, nodeCount = 0;


        roofs.forEach((roof: BuildingJSON, idx: number) => {
            const {nodes, edges, faces} = roof;
            nodes.forEach(pos => {
                if (pos.Y !== undefined) pos.Y *= -1;
                if (pos.Z !== undefined && pos.Z < minVal) minVal = pos.Z;
            });




            if (idx > 0) {
                faces.forEach(face => {
                    if (!face.shell) return;
                    for (let i = 0; i < face.shell.length; i++) {
                        face.shell[i] += nodeCount;
                    }
                    if (face.holes && face.holes.length) {
                        face.holes.forEach(hole => {
                            if(hole.length) {
                                for (let i = 0; i < hole.length; i++) {
                                    hole[i] += nodeCount;
                                }
                            }
                        });
                    }
                    if (faces.length === 1){
                        face.flatRoof = true;
                    }
                });
                edges.forEach(edge => {
                    if (!edge.nodes) return;
                    for (let i = 0; i < edge.nodes.length; i++) {
                        edge.nodes[i] += nodeCount;
                    }
                });

                roofs[0].nodes.push(...nodes);
                roofs[0].faces.push(...faces);
                roofs[0].edges.push(...edges);
            }
            nodeCount += nodes.length;
        });


        const {nodes, faces, edges} = roofs[0] as BuildingJSON;



        const nodeArr: NodePos[] = nodes.map(pos => ({x: pos.X!, y: pos.Z!, z: pos.Y!, oldY: pos.Z}));

        edges.forEach(edge => {
            if(!edge.nodes ||edge.nodes[0] ===-1) return;
            edge.posArr = GetPosArr(nodeArr, edge.nodes);
        });

        const {siteBuildingData, masterDataList} = useViewerStore.getState();
        const holeInfoArr = [], angArr: OriginalAngle[] = [];


        faces.forEach(face => {
            const {shell, sq_footage, holes, pitch, azimuth,roof_number} = face, facePosArr = GetPosArr(nodeArr, shell);

            const existAng = angArr.find(item => item.tilt === GetRoundNum(pitch, 2) && item.azimuth === GetRoundNum(azimuth, 4));
            if (!existAng) angArr.push({ tilt: GetRoundNum(pitch, 2), azimuth: GetRoundNum(azimuth, 4) });
            face.oriAng = { tilt: GetRoundNum(pitch, 2), azimuth: GetRoundNum(azimuth, 4) };
            face.posArr = facePosArr;
            face.sq_footage_from_aurora = sq_footage;
            face.size = sq_footage;
            face.roof_number_from_aurora = roof_number;

            const roofId = isGlb ? face.roof_tag_id : roof_number;
            let roofData: RoofDesignData | undefined;
            siteBuildingData.forEach(building => {
                building.Roofs.forEach(data => {
                    if (data.Designation === `R${roofId}`) return roofData = data;
                });
            })
            const qnRoofId = roofData?.Questionable_Roof_Id ?? 0;
            const roofNote = masterDataList?.QuestionableRoof.find(data => data.value === qnRoofId);
            face.questionableRoof = roofNote?.label ?? '';
            face.questionableRoofId = roofData?.Questionable_Roof_Id ?? 0;
            face.questionableRoofNotes = roofData?.Questionable_Roof_Notes

            var faceHole: { posArr: XYZCoordinates[] }[] = [];
            if (holes && holes.length) {
                faceHole = [];
                holes.forEach(holeItem => {
                    holeItem.posArr = GetPosArr(nodeArr, holeItem);
                    faceHole.push({posArr: holeItem.posArr});
                });
            }
            holeInfoArr.push(faceHole);
        });

        self.roofRotY = 0;
        self.roofJson = null;

        for (let i = edges.length - 1; i >= 0; i--) {
                const edge = edges[i];
                if (edge.nodes && edge.nodes.length >= 2 && edge.nodes[0] === -1 && edge.nodes[1] === -1) {
                    edges.splice(i, 1);
                }
        }

        const flatRoofFaces = faces.filter(face => face.flatRoof === true);
        if (flatRoofFaces.length > 0) {
            flatRoofFaces.forEach(face => {

                //Caclulate Edges for fround mount walls ( frame )
                if (face.lines && face.lines.length) {
                    const additionalEdges: EdgeJson[] = face.lines.map((line, idx) => {
                        const nextPos = idx === face.lines!.length - 1 ? face.lines![0].points[0] : face.lines![idx + 1].points[0];
                        const points = [line.points[0], nextPos];
                        return {
                            type: 'rake',
                            posArr: points,
                            isGroundMountEdge: true,
                            roofFaceId: face.roofFaceId
                        };
                    });

                    edges.push(...additionalEdges);

                    face.posArr = face.posFlatArr;
                }
            })
        }
        self.roofs = roofs;

        await drawDesign(self, false, modelType, obstructions);


        if (isGlb) {
            /**** For calculating irradiancemonth for saved data ***********/
            const oldIrradianceMonth = roofs[0]?.faces[0]?.irradianceMonth;
            if(!irradianceMonth || irradianceMonth === undefined || irradianceMonth.length === 0){
                if(oldIrradianceMonth){
                    useViewerStore.setState({irradianceMonth: oldIrradianceMonth});
                    self.irradianceMonth = oldIrradianceMonth;
                } else {
                    await GetTimeZone(self);
                }
            } else {
                useViewerStore.setState({irradianceMonth: irradianceMonth});
                self.irradianceMonth = irradianceMonth;
            }

            /**** For calculating irradinacemonth for saved data ***********/
            if (self.sunVecArr) SetSunPathGeo(self.sunGroup, self.sunVecArr, sunInfo);
        } else {
            loadingContext.setMessage({ message: 'Getting Time Zone and Shade...' });
            await GetTimeZone(self);
        }

        EmptyGroup(self.treeGroup);
        trees.forEach((treeInfo: TreeJson) => {
            treeInfo.y *= -1;
            treeInfo.crown_radius *= 2;
            const treeGroup = GetTreeObj(treeInfo, self.crownModel);
            treeGroup.children.forEach((child: any) => {
                self.meshArr.push(child);
                child.castShadow = true;
            });
            treeGroup.select = false;
            if (modelType === 'glb' && treeInfo.incrossArr) {
                treeGroup.children[2].incrossArr = treeInfo.incrossArr;
            }

            if (treeInfo.delStatus !== undefined) {
                ChangeTreeDelete(treeGroup, treeInfo.delStatus);
            }

            if (treeInfo.crownKey) {
                ChangeTreeShape(self, treeGroup, treeInfo.crownKey);
            }

            self.treeGroup.add(treeGroup);
            SetTreeSize(self, treeGroup, treeInfo);
        });

        ModelLoadInit(self);

        registerCalculations(self);

        SetLineSnap(self, true);
        self.reLabelTreeGroup();

        self.obstGroup.children.forEach(obst => {
            if (obst.children[0].children[0].children[0].userData.delStatus) {
                DeleteObst(obst, self);
            }
        });



        //Set Imagery Position
        if (mapPosition) {
           //Preventing the map from going too far off or out of bounds
            if(Math.abs(mapPosition.x) >= 2*mapSize || Math.abs(mapPosition.z) >= 2*mapSize) {
                mapPosition.x = 0
                mapPosition.z = 0
            }
            self.mapCustom!.position.set(mapPosition.x, self.mapCustom!.position.y, mapPosition.z);
        }
        if(modelType === 'glb'){

            if(testRoofJson?.roofBaseHeight && testRoofJson?.roofOriginalHeight){
                useViewerStore.setState({
                    wallInitialHeight: testRoofJson.roofOriginalHeight,
                    wallEditedHeight: testRoofJson.roofBaseHeight
                })

                setTimeout(()=>{
                    self?.setWallSize(testRoofJson.roofBaseHeight-testRoofJson.roofOriginalHeight);
                },1000)
            }

        }







        self.setCameraView('3d',true);
        self.setSelectType(SelectType.roof);



        siteCalculationState.needsUpdate(ACCESS_MULTIPLIERS, 0);
        siteCalculationState.useCalculations(ACCESS_MULTIPLIERS);

        sleep(1000).then(async () => {
            // renderer does not fully load if document is not in focus, causing shade calculations to be incorrect
            // rerun shade calculations if document was not focused

            const focused = document.hasFocus();
            while (!document.hasFocus()) {
                await sleep(250);
            }

            if (!focused) {
                siteCalculationState.needsUpdate(SHADE_CALCULATIONS);
            }

            // await siteCalculationState.useCalculations(SHADE_CALCULATIONS);
        });
        useViewerStore.setState({loadingCompleted: true})


        self.ifContainsFlatRoofAndEnableBallastedRacking()
        syncSetbackVisibilityForDetachedBuildings()
        self.hideObject(HideObjectType.GhostObst, true);
        

        // if (mapProperties?.imageryType !== ImageryOptions.CUSTOM) {
        //     CenterMapCoodinates(self, mapProperties?.imageryType);
        // }




    } finally {
        loadingContext.dispose();
    }
}

function registerCalculations(self: Viewer){
    const {savedLocationCoordinates: location} = useViewerStore.getState();

    // Fetch Roof Access Multipliers
    siteCalculationState.registerCalculation(ACCESS_MULTIPLIERS, async ({needsUpdate}: {needsUpdate: number[]}) => {
        const {accessoryBuildingList} = useViewerStore.getState();
        const activeRoofMeshArr: RoofMesh[] = [], angArr: OriginalAngle[] = [];
        const loadingContext = new LoadingContext();
        loadingContext.setToBackground(true);
        loadingContext.setMessage({ title: '',  message: `Loading Access Multipliers...`});
        self.modelGroup.children[0].traverse((child: any) => {
            if (child.roofFaceId === undefined || child.disableModule || activeRoofMeshArr.length === self.roofs[0].faces.length) return;
            // Skip accessory buildings
            if (accessoryBuildingList.includes(child.userData.buildingName)) return;
            // Skip if small_face (Roof Area below 50 sqft)
            if (child.userData.roof_size_type === 'small_face') return;
            const face = self.roofs[0].faces.find((f: FaceItem) => f.roofFaceId === child.roofFaceId);
            if (!face || !face.oriAng) return;
            const tilt = GetRoundNum(face.oriAng.tilt, 2), azimuth = GetRoundNum(face.oriAng.azimuth, 4);
            child.oriAng = {tilt, azimuth};
            const existAng = angArr.find(item => GetRoundNum(item.tilt, 2) === tilt && GetRoundNum(item.azimuth, 4) === azimuth);
            if (!existAng) {
                angArr.push({ tilt, azimuth, roofTagId: child.userData.roof_tag_id });
            }
            activeRoofMeshArr.push(child);
        });

        try {
            await GetFaceProdAPI(location, angArr, activeRoofMeshArr, Math.min(...needsUpdate), (error: string, isFatal: boolean) => {
                useViewerStore.setState({isSavingInProgress: isFatal});
                self.viewerAlert({
                    show: true,
                    title: "Note : Fetching Production Multipliers",
                    message: error,
                    messageType: AlertType.error,
                    isModal: true
                });
            });
        } catch (e) {
            useViewerStore.setState({isSavingInProgress: true});
            const errorMessage = e instanceof Error ? e.message : String(e);
            self.viewerAlert({
                show: true,
                title: "Note : Fetching Production Multipliers",
                message: errorMessage,
                messageType: AlertType.error,
                isModal: true
            });
            throw e;
        }

        loadingContext.dispose();
    }, { needsUpdate: [0] });

    // To Fetch Ideal Multipliers
    siteCalculationState.registerCalculation(FACE_IDEAL_API, async () => {
        const activeRoofMeshArr: RoofMesh[] = [], angArr: OriginalAngle[] = [];
        const loadingContext = new LoadingContext();
        loadingContext.setToBackground(true);
        loadingContext.setMessage({ title: '',  message: `Loading Ideal Multipliers...`});
        self.modelGroup.children[0].traverse((child: any) => {
            if (child.roofFaceId === undefined || child.disableModule || activeRoofMeshArr.length === self.roofs[0].faces.length ) return;
            const face = self.roofs[0].faces.find((f: FaceItem) => f.roofFaceId === child.roofFaceId);
            child.oriAng = { ...face.oriAng };
            const existAng = angArr.find(item => item && GetRoundNum(item.tilt, 2) === GetRoundNum(child.oriAng.tilt, 2) && GetRoundNum(item.azimuth, 4) === GetRoundNum(child.oriAng.azimuth, 4));
            if (!existAng) {
                angArr.push({ ...face.oriAng });
            }
            activeRoofMeshArr.push(child);
        });
        await GetFaceIdealAPI(location, angArr);
        loadingContext.dispose();
    }, { needsUpdate: [true] });

    // For Ray Testing & Shade Weight Calculations
    siteCalculationState.registerCalculation(SHADE_CALCULATIONS, async ({needsUpdate}: { needsUpdate: number[] }) => {

        await GenShadeOnFace(self.roofs[0].faces, self);
    }, { needsUpdate: [true] });

    // To Calculate Multipliers & Production ; To Update module colors
    siteCalculationState.registerCalculation(MODULE_GRAPH, async () => {
        SetShadeFinalResult(self);
        await SetModuleGraph(self);
    }, { needsUpdate: [true] });


    // Adds Callbacks to excecute next calculation
    // Calculation Order: ACCESS_MULTIPLIERS -> FACE_IDEAL_API -> SHADE_CALCULATIONS -> MODULE_GRAPH
    siteCalculationState.addUpdatedListener(ACCESS_MULTIPLIERS, async () => {
        siteCalculationState.needsUpdate(FACE_IDEAL_API);
        await siteCalculationState.useCalculations(FACE_IDEAL_API);
    });

    siteCalculationState.addUpdatedListener(FACE_IDEAL_API, async () => {
        siteCalculationState.needsUpdate(SHADE_CALCULATIONS);
        await siteCalculationState.useCalculations(SHADE_CALCULATIONS);
    });

    // siteCalculationState.addUpdatedListener(SHADE_CALCULATIONS, async () => {
    //     siteCalculationState.needsUpdate(MODULE_GRAPH);
    //     await siteCalculationState.useCalculations(MODULE_GRAPH);
    // });

}


export function createPolygonExtrudeGeometry(nodes?: NodePos[], height = 1, normal_top?: { X: number; Y: number; Z: number }) {
    const sceneViewer = useViewerStore.getState().sceneViewer;

    if (!nodes || nodes.length < 3) {
        return new THREE.BoxGeometry(1, height, 1);
    }

    const nodesCentroid = computeCentroid(nodes);
    const centroidVector = new THREE.Vector3(nodesCentroid.X, nodesCentroid.Z, -nodesCentroid.Y);
    const downVector = new THREE.Vector3(0, -1, 0);

    const raycaster = new THREE.Raycaster(centroidVector, downVector, 0, 1000);
    const intersects = raycaster.intersectObjects(sceneViewer.roofMeshArr, false);

    if (intersects.length > 0) {
        const intersect = intersects[0];
        const intersectPoint = intersect.point;
        height = centroidVector.distanceTo(intersectPoint);
    }

    const shape2D = nodes.map(n => new THREE.Vector2(n.X!, n.Z!));
    const faces = THREE.ShapeUtils.triangulateShape(shape2D, []);

    const vertexCount = nodes.length;

    const topPositions = new Float32Array(vertexCount * 3);
    const topVectors: THREE.Vector3[] = [];

    for (let i = 0; i < vertexCount; i++) {
        const node = nodes[i];
        const x = node.X!;
        const y = node.Z!;
        const z = -node.Y!;

        topPositions[i * 3 + 0] = x;
        topPositions[i * 3 + 1] = y;
        topPositions[i * 3 + 2] = z;

        topVectors.push(new THREE.Vector3(x, y, z));
    }

    let normal = new THREE.Vector3();
    {
        const v0 = topVectors[0];
        const v1 = topVectors[1];
        const v2 = topVectors[2];
        const edge1 = new THREE.Vector3().subVectors(v1, v0);
        const edge2 = new THREE.Vector3().subVectors(v2, v0);
        normal.crossVectors(edge1, edge2).normalize();
    }

    const useTopPositive = normal_top ? normal_top.Y <= 0 : normal.y <= 0;

    const bottomPositions = new Float32Array(vertexCount * 3);
    for (let i = 0; i < vertexCount; i++) {
        const tx = topPositions[i * 3 + 0];
        const ty = topPositions[i * 3 + 1];
        const tz = topPositions[i * 3 + 2];

        bottomPositions[i * 3 + 0] = tx - normal.x * height;
        bottomPositions[i * 3 + 1] = ty - normal.y * height;
        bottomPositions[i * 3 + 2] = tz - normal.z * height;
    }

    const positions = new Float32Array(vertexCount * 2 * 3);
    positions.set(topPositions, 0);
    positions.set(bottomPositions, vertexCount * 3);

    const indices: number[] = [];

    for (let i = 0; i < faces.length; i++) {
        const [i0, i1, i2] = faces[i];
        if (useTopPositive) {
            indices.push(i0, i1, i2);
        } else {
            indices.push(i2, i1, i0);
        }
    }

    // Bottom face (reverse winding of top)
    for (let i = 0; i < faces.length; i++) {
        const [i0, i1, i2] = faces[i];
        if (useTopPositive) {
            indices.push(i2 + vertexCount, i1 + vertexCount, i0 + vertexCount);
        } else {
            indices.push(i0 + vertexCount, i1 + vertexCount, i2 + vertexCount);
        }
    }

    // Side faces - build quads per edge (two triangles) with consistent winding
    for (let i = 0; i < vertexCount; i++) {
        const iNext = (i + 1) % vertexCount;
        const topA = i;
        const topB = iNext;
        const botA = i + vertexCount;
        const botB = iNext + vertexCount;

        if (useTopPositive) {
            // topA -> topB -> botA  and topB -> botB -> botA
            indices.push(topA, topB, botA);
            indices.push(topB, botB, botA);
        } else {
            // reverse the winding
            indices.push(botA, topB, topA);
            indices.push(botA, botB, topB);
        }
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setIndex(new THREE.BufferAttribute(new Uint32Array(indices), 1));
    geometry.setAttribute(
        'position',
        new THREE.BufferAttribute(positions, 3)
    );

    geometry.computeVertexNormals();

    return geometry;
}


function normalizeNodes(nodes: {X: number, Y: number, Z: number}[], designFormat?: string | null) {
    const zReverse = designFormat === 'XML' ? 1 : -1;

    return nodes.map(n => {
        if (designFormat === 'XML') {
            return { X: n.X, Y: n.Y, Z: n.Z };
        }
        return {
            X: n.X,
            Y: n.Z,
            Z: n.Y! * zReverse,
        };
    });
}

function normalizePosition(item: ObstructionJSON, designFormat: string | null) {
    if (designFormat === 'XML') {
        return { x: item.x ?? 0, y: item.y ?? 0, z: item.z ?? 0 };
    }
    return {
        x: item.x ?? 0,
        y: item.z ?? 0,
        z: -(item.y ?? 0),
    };
}

function computeCentroidNew(nodes: {X?: number, Y?: number, Z?: number}[]) {
    const sum = nodes.reduce(
        (a, n) => {
            a.x += n.X!;
            a.y += n.Y!;
            a.z += n.Z!;
            return a;
        },
        { x: 0, y: 0, z: 0 }
    );

    return {
        x: sum.x / nodes.length,
        y: sum.y / nodes.length,
        z: sum.z / nodes.length,
    };
}

function computeRectFromNodes(nodes: {X: number, Y: number, Z: number}[]) {
    const edges = [
        GetDis(nodes[0], nodes[1], true),
        GetDis(nodes[1], nodes[2], true),
        GetDis(nodes[2], nodes[3], true),
        GetDis(nodes[3], nodes[0], true),
    ];

    edges.sort((a, b) => b - a);

    const length = edges[0];
    const width = edges[2];

    const p0 = nodes[0];
    const p1 = nodes[1];
    const rotY = -Math.atan2(p1.Z! - p0.Z!, p1.X! - p0.X!);

    return { width, length, rotY };
}
function computeCentroidWorld(
    nodes: { X?: number; Y?: number; Z?: number }[],
    designFormat?: string | null
) {
    if (!nodes || nodes.length === 0) {
        return { x: 0, y: 0, z: 0 };
    }

    let sx = 0, sy = 0, sz = 0;

    for (const n of nodes) {

        if (designFormat === 'XML') {
            // XML already world aligned
            sx += n.X ?? 0;
            sy += n.Y ?? 0;
            sz += n.Z ?? 0;
        } else {
            // Match normalizePosition()
            sx += n.X ?? 0;
            sy += n.Z ?? 0;
            sz += -(n.Y ?? 0);
        }
    }

    const inv = 1 / nodes.length;

    return {
        x: sx * inv,
        y: sy * inv,
        z: sz * inv,
    };
}




function CreateObstructions(self: Viewer, obstructions: ObstructionJSON[] = []) {
    const virObsMesh = self.virObs.children[0].children[0].children[0];
    self.pushMode = true;
    self.virObs.visible = true;

    obstructions.forEach(item => {
        const type = item.type;
        const isPolygon = type === 'polygon' || type === 'obst-cube' || type === 'default-polygon';
        //DEBUG : Visualize Obstruction Center Position (Top of the Obstruction)
        // const sphereGeometry = new THREE.SphereGeometry(0.1, 16, 16);
        // const sphereMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 });
        // const sphereMesh = new THREE.Mesh(sphereGeometry, sphereMaterial);
        // const worldPosition = normalizePosition(item, self.designFormat);
        // sphereMesh.position.set(worldPosition.x, worldPosition.y, worldPosition.z);
        // self.scene.add(sphereMesh);


        // For Custom OD Created Cubes Obst without nodes, generate 4 nodes based on width, length, and height
        if (isPolygon && item.isCustom ) {

            const halfW = (item.width || 0) / 2;
            const halfL = (item.length || 0) / 2;
            const halfH = (item.height || 0) / 2;

            item.nodes = [
                { X: (item.x || 0) - halfW, Y: (item.y || 0) - halfH, Z: (item.z || 0) - halfL },
                { X: (item.x || 0) + halfW, Y: (item.y || 0) - halfH, Z: (item.z || 0) - halfL },
                { X: (item.x || 0) + halfW, Y: (item.y || 0) - halfH, Z: (item.z || 0) + halfL },
                { X: (item.x || 0) - halfW, Y: (item.y || 0) - halfH, Z: (item.z || 0) + halfL },
            ];
        }

        // Normalize normal
        const rawNormal = item.normal_top || {};
        const normalTop = {
            x: rawNormal.X ?? rawNormal.x ?? 0,
            y: rawNormal.Y ?? rawNormal.y ?? 0,
            z: rawNormal.Z ?? rawNormal.z ?? 1,
        };

        const isFlat = normalTop.x === 0 && normalTop.y === 0;

        const isSavedDesign = !!item.roofId; // or your saved flag



        // Normalize nodes
        const rawNodes = (item.nodes || []).map(n => ({
            X: n.X ?? n.x ?? 0,
            Y: n.Y ?? n.y ?? 0,
            Z: n.Z ?? n.z ?? 0,
        }));

        const nodes = normalizeNodes(rawNodes, self.designFormat);
        const originalNodes = JSON.parse(JSON.stringify(rawNodes));

        const hasValidDims =
            Number.isFinite(item.width) &&
            Number.isFinite(item.length) &&
            item.width > 0 &&
            item.length > 0;


        //DEBUG : Visualize Nodes for polygonal obstructions
        // if (isPolygon) {
        //     const center = computeCentroidNew(nodes);
        //     item.x = center.x;
        //     item.y = center.y;
        //     item.z = center.z;
        //     nodes.forEach(node => {
        //         const nodeSphereGeometry = new THREE.SphereGeometry(0.1, 8, 8);
        //         const nodeSphereMaterial = new THREE.MeshBasicMaterial({ color: 0x0000ff });
        //         const nodeSphereMesh = new THREE.Mesh(nodeSphereGeometry, nodeSphereMaterial);
        //         nodeSphereMesh.position.set(node.X, node.Y, node.Z);
        //         self.scene.add(nodeSphereMesh);
        //     });
        // }



        // POLYGONS
        if (isPolygon && nodes.length === 4 ) {
            item.isPolygonWithFourNodes = true;

            if (!hasValidDims) {
                const rect = computeRectFromNodes(nodes);
                item.width = rect.width;
                item.length = rect.length;
                item.groundRotY = rect.rotY;
            }


            if(isSavedDesign) {
                const worldPosition = normalizePosition(item, self.designFormat);
                item.x = worldPosition.x;
                item.y = worldPosition.y;
                item.z = worldPosition.z;
            }
            else{
                const center = computeCentroidNew(nodes);
                item.x = center.x;
                item.y = center.y;
                item.z = center.z;
            }

           


        }
        else if (isPolygon && nodes.length === 3) {
            item.isPolygonWithFourNodes = false;
            const rect = computeRectFromNodes(nodes);
            item.groundRotY = rect.rotY;
            const center = computeCentroidNew(nodes);
            item.x = center.x;
            item.y = center.y;
            item.z = -center.z;

        }

            //  CIRCLES / CYLINDERS
        else if (!isPolygon && item.radius && item.radius > 0) {
            const pos = normalizePosition(item, self.designFormat);
            item.x = pos.x;
            item.y = pos.y;
            item.z = pos.z;
            item.width = item.length = item.radius * 2;
        }

        virObsMesh.sides = 8;
        SetVirObst(self, item);

        virObsMesh.userData = {
            delStatus: item.delStatus,
            initialHeight: self.virObs.position.y,
            nodes: originalNodes,
        };

        virObsMesh.isObstructionOnRoof = true;
        self.virObs.isDefaultObstruction = !(item.isCustom ?? false);
        self.virObs.userUpdatedDefaultDimensions =
            item.userUpdatedDefaultDimensions ?? false;

        SetCloneVirObj(self, nodes, isFlat);
    });

    self.virObs.isDefaultObstruction = false;
    SetDefaultObst(self);
}

function SetDefaultObst(self: Viewer) {
    self.pushMode = true;
    self.virObs.visible = true;
    ChangeObstShape(self, 1);
    ChangeObstWidth(self, defaultObsW);
    ChangeObstLength(self, defaultObsW);
    ChangeObstHeight(self, defaultObsW);
    ChangeObstSides(self, 6);
    ChangeObstRadius(self, defaultObsW);

    setTimeout(() => {
        self.pushMode = false;
        self.virObs.visible = false;
    }, 0);
}

function SetVirObst(self: Viewer, info: ObstructionJSON) {
    const {virObs, roofMeshArr, mapCustom} = self, {x, y, z, type, radius, width, length, height, groundRotY, normal_top} = info;
    const virMesh = virObs.children[0].children[0].children[0];

    let shape;
    if (type === 'obst-cube' || (type === 'polygon'  && info.isCustom && (!info.nodes || info.nodes.length===0) ) || info.isPolygonWithFourNodes ) {
        shape = 1;
    } else if (type === 'circle' || type === 'obst-polygon') {
        shape = 2;
    } else if (type === 'cube' || type === 'obst-cylinder' || type === 'cylinder') {
        shape = 3;
    }
    else if( (type === 'polygon' && (info.nodes.length>4) ) || (type === 'polygon' && (info.nodes.length==3)) || type === 'default-polygon'){
        shape = 4;
    }
    virMesh.isPolygonWithFourNodes = info.isPolygonWithFourNodes ?? false;

    if (shape) ChangeObstShape(self, shape , info.nodes, normal_top);

    if (radius && (shape === 2 || shape === 3)) {
        ChangeObstRadius(self, radius * 2, true);
    } else {
        ChangeObstWidth(self, width);
        ChangeObstLength(self, length);
    }

    const arrowOrigin = new THREE.Vector3(x, y, z);
    const arrowDir = new THREE.Vector3(0, -1, 0);


    const raycaster = new THREE.Raycaster(arrowOrigin, arrowDir);



    const intersects = raycaster.intersectObjects([...roofMeshArr, self.planeMesh], false) as any[];
    const intersect = intersects.find(i => i.object.meshType === 'roof') ?? intersects[0];
    const vHeight = height || (y - Math.max(0, intersect?.point.y ?? 0));

    if(shape !== 4) {
        ChangeObstHeight(self, vHeight);
        virObs.position.set(x, y - vHeight, z);
    }
    if (!intersect) return;


    const {object, point} = intersect;
    const {rotX, rotY} = object;

    virMesh.rotX = rotX || 0;
    virMesh.rotY = rotY || 0;

    if (object.meshType === SelectType.roof) {
        virObs.roofId = virMesh.roofId = object.roofFaceId;
    } else {
        virObs.roofId = virMesh.roofId = null;
        virMesh.roofPos = null;
        if (shape===1 && groundRotY) {
            virMesh.rotY = groundRotY;
        }
    }
    virMesh.roofPos = {x: point.x, y: point.y, z: point.z};
}

const isMeshOnObject = (mesh: THREE.Mesh, object: THREE.Object3D) => {
    const meshBox = new THREE.Box3().setFromObject(mesh);
    const objectBox = new THREE.Box3().setFromObject(object);
    return meshBox.intersectsBox(objectBox);
}



export async function drawDesign(self: Viewer, isGroundMount = false, modelType?: string, obstructions?: ObstructionJSON[]) {

    if (!self.roofs) return;

    const oldRoof: any = self.roofGroup.children[0];

    //Assign House Id
    let oldHouseId = oldRoof ? oldRoof.houseId : GetIdStr();

    self.meshArr = self.meshArr.filter(mesh => mesh.meshType === 'tree' || mesh.meshType === 'obst');

    self.updatePitchAdjustedByUserFlag()

    //Empty Old Roof Group
    EmptyGroup(self.roofGroup);

    self.mapCustom!.visible = true;

    const {nodes, faces: rawFaces} = self.roofs[0], nodeArr = [], nodeRoofArr = [];

    // De-duplicate faces to avoid drawing overlapping roof meshes
    // which can block raycasting and module selection.
    const faces: FaceItem[] = [];
    const seenFaceKeys = new Set<string>();

    (rawFaces as FaceItem[]).forEach((face) => {
        const hasPosArr = Array.isArray(face.posArr) && face.posArr.length > 0;
        const posKey = hasPosArr
            ? face.posArr
                .map((p) => `${p.x.toFixed(3)},${p.y.toFixed(3)},${p.z.toFixed(3)}`)
                .join("|")
            : "";

        const idPart = face.roofFaceId != null ? `id:${face.roofFaceId}` : "id:none";
        const key = `${idPart}|pos:${posKey}`;

        if (seenFaceKeys.has(key)) {
            // Skip exact-duplicate face (same id & geometry)
            return;
        }

        seenFaceKeys.add(key);
        faces.push(face);
    });

    if (faces[0]?.houseId) oldHouseId = faces[0].houseId;

    //---------ROOF DRAWING------------

    //Create new Roof Group
    const roofGroup: any = new THREE.Group()

    const meshArr: any[] = [], roofMeshArr: RoofMesh[] = []

    roofGroup.houseId = oldHouseId;

    let lastUsedRoofTagIndex =1


    //---------SETBACK AND PATHWAY DRAWING------------

    if (modelType !== 'glb') {
        const apiCount = Math.ceil(nodes.length / 99), latlonStrArr = [];
        for (let i = 0; i < apiCount; i++) {
            const lastNum = 99 * (i + 1) < nodes.length ? 99 : nodes.length - 99 * i;
            var latlonStr = i === 0 ? self.mapCoordinates.latitude + ',' + self.mapCoordinates.longitude + '|' : '';
            for (let j = 0; j < lastNum; j++) {
                const nodeNum = i * 99 + j, node = nodes[nodeNum];
                if (!node.X && !node.Y) {
                    node.X = node.x;
                    node.Y = node.z;
                    node.Z = node.y;
                }
                const location = GetLatLon(self.mapCoordinates, {x: node.X, z: node.Y});
                if (j > 0) latlonStr += '|';
                latlonStr += location.latitude + ',' + location.longitude;
            }
            latlonStrArr.push(latlonStr);
            if (latlonStrArr.length === apiCount) {

                const nearPoint = await GetNearRoadPoint(self, latlonStrArr);

                self.roadNearPoint = nearPoint;

                await SetPathway(self);
            }
        }
    } else {
        await SetPathway(self);
    }


    faces.forEach((face: FaceItem, fIdx: number) => {

        //Draw Roof from Faces and shade points on Roof
        drawRoofForGivenFace({
            face: face,
            associatedRoofGroup: roofGroup,
            isDrawingGroundMount : false,
            meshArr : meshArr,
            roofMeshArr : roofMeshArr,
            lastUsedRoofTagIndex
        });
        lastUsedRoofTagIndex++;

    });


    //----------WALL DRAWING------------

    //Draw Walls from Edges
    self.roofs[0].edges.forEach((edge: EdgeJson) => {
        drawWallForGivenEdge( edge, roofGroup, undefined, meshArr );
    })


    //---------BOUND DRAWING------------
    //BOUND => BOUND is a Perimeter Mesh that covers all buildings together

    const boundMesh = GetHouseBound(roofGroup);

    //DEBUG => Visualize Bound Mesh ( This shows Bound of all buildings together )
    // const bbox = new THREE.BoxHelper( boundMesh, 0xff0000 );
    // self.totalGroup.add( bbox );

    roofGroup.scale.y = roofGroup.sclY;
    roofGroup.rotation.y = self.roofRotY || 0;
    roofGroup.userData.originalPosition = roofGroup.position;
    self.roofGroup.add(roofGroup);

    //If Roof is outside map, then reposition terrain map
    const isRoofOutsideMap = self.mapCustom ? !isMeshOnObject(boundMesh, self.mapCustom) : false;

    if(isRoofOutsideMap){
        const boundCenterX = boundMesh.position.x;
        const boundCenterZ = boundMesh.position.z;
        self.mapCustom!.position.set(boundCenterX, self.mapCustom!.position.y, boundCenterZ);
    }




    useViewerStore.setState({savedRoofFaceIdArray: faces.map((face: FaceItem) => face.roofFaceId)});

    self.nodeArr = [];
    self.nodeRoofArr = [];

    for (const node of self.roofs[0].nodes) {
        self.nodeArr.push({x: node.X, y: 0, z: node.Y});
        self.nodeRoofArr.push({x: node.X, y: node.Z, z: node.Y});
    }


    self.boundGroup.add(boundMesh);

    //Update the meshArr and roofMeshArr after roof and walls are drawn
    self.meshArr.push(...meshArr);
    self.roofMeshArr = roofMeshArr;
    self.roofLines = GetRoofLines(self.roofMeshArr);


    //---------EDGE DRAWING ( BLACK BORDER )------------

    //Remove old black border edges
    self.edgeMeshArr.forEach((edgeMesh) => {
        if(edgeMesh){
            disposeObject(edgeMesh)
        }
    })

    self.roofMeshArr.forEach((roofMesh) => {
        drawBlackBorderToRoofEdges( self, roofGroup, roofMesh );
    })

    //---------OBSTRUCTION DRAWING-----------

    //Empty Old Obstruction Group
    EmptyGroup(self.obstGroup);

    //Pre setup for Default Obstruction
    CheckDefaultObst(self.obstGroup.children);

    // Clean Incorrectly saved Obstruction / Floating
    if (modelType==='glb') {
        obstructions = obstructions?.filter((obstruction) => {
            // Keep only valid obstructions
            return obstruction.y < 90
        });
    }


    //Create Obstructions Meshes
    CreateObstructions(self, obstructions);

    // DO NOT REMOVE : THIS IT TO FIX INCORRECT ORIENTATION OF SOME OBSTRUCTIONS
    for (const obst of self.obstGroup.children) {
        AdjustObstOrientation(obst);
    }



    faces.forEach((face: FaceItem, fIdx: number) => {

        const shapeMesh = roofMeshArr.find(rm => rm.roofFaceId === face.roofFaceId);

        if (face.lines
            && !face.surfaceMount
            && shapeMesh?.userData.roof_size_type === 'normal_face'
            && !useViewerStore.getState().accessoryBuildingList.includes(face.buildingName.toString())
        ) {
            AddPathwayMesh(face, shapeMesh, shapeMesh.pos2DArr, self);
        }
    })

    //---------ACCESSORY BUILDING SETUP------------

    for (const roof of self.roofs) {
        if (roof.building_usage_type === 'accessory') {
            self.preSelRoofId = roof.faces[0].roofFaceId;
            SetBuildingModule(self, true);
            self.preSelRoofId = null;
        }
    }



    //---------MODULE DRAWING / LOAD MODULE------------


    if (modelType === 'glb') {

        //--------------LOADING SAVED DESIGN----------------

        //Setup Modules Placement
        initForModulePlacement(self);

        //Load Shade Info to Roof Meshes
        self.modelGroup.totalShadeCount = 0;
        self.roofMeshArr.forEach((shapeMesh, rIdx) => {
            const selFace: FaceItem = faces[rIdx];
            const shadeArr = shapeMesh.userData.shadeArrForRoof
            shadeArr.forEach((shade, sIdx) => {
                if (!selFace.shadeInfo || sIdx >= selFace.shadeInfo.length) return;
                const {onModule, monthArr, ptHashVal} = selFace.shadeInfo[sIdx];
                shade.onModule = onModule;
                shade.monthArr = [...(monthArr ?? [])];
                shade.ptHashVal = ptHashVal ?? 0;
            });
        });

        //Load Saved Modules to Roof Meshes
        self.roofMeshArr.forEach((shapeMesh, rIdx) => {
            if (shapeMesh.disableModule) return;
            self.modelGroup.totalShadeCount!++;
            const selFace: FaceItem = faces[rIdx];
            const modules: any[] = [];
            const moduleArr = selFace.moduleArr ?? [];

            for (const module of moduleArr) {
                if (modules.find(m => m.moduleId === module.moduleId)) {
                    continue;
                }
                modules.push(module);
            }

            shapeMesh.moduleArr = modules;

            //Hide Ghost Obstruction Mesh
            self.hideObject(HideObjectType.GhostObst, true);

            const showLabel = useViewerStore.getState().isModuleMultiplierLabelVisible;

            //Ballasted Rack Type Module Check
            useViewerStore.setState({isBallastedRackTypeModuleActive: false});

            if(shapeMesh.userData.pitchOverride < 3 && (modules && modules[0]?.userData?.isBallastedRackType ) ){
                useViewerStore.setState({activeBallastRackDirection: 'horizontal'})
                useViewerStore.setState({isBallastedRackTypeModuleActive: true});
            }
            //Calculate and Update Max Fill Module Count for Roof
            updateModuleCount(self,"port",true)
            updateModuleCount(self,"land",true)
            updateModuleCount(self,"both",true)

            //Add Modules to Roof
            modules.forEach((item) => {
                AddIndividualMode(shapeMesh, item, true, self.moduleMeshArr, self.meshArr, showLabel,true);
            });
        });

        //Saved Design Loaded

        const roofModules: SavedRoofModulesLayout = [];

        roofMeshArr.forEach(roof => {
            roofModules.push({
                roofFaceId: roof.roofFaceId,
                moduleArr: getRoofModuleMeshes(roof).map(m => getModuleMeshInfo(m))
            });

            //Set Pathway Status
            roof.children.forEach((child: any) => {
                if (child.pathwayId) {
                    SetPathwayValue(self, child.pathwayId, !!roof.lines.find(l => l.lineId === child.pathwayId)?.active);
                }
            });


        });

        useViewerStore.setState({savedRoofModulesLayout: roofModules});

        siteCalculationState.needsUpdate(MODULE_GRAPH);
        siteCalculationState.useCalculations(MODULE_GRAPH);
    }
    else {
        //--------------LOADING FRESH ORIGINAL SITE ( FIRST LOAD FROM AURORA JSON )----------------


        //Calculate and Update Max Fill Module Count for Roof
        updateModuleCount(self, "port", true)
        updateModuleCount(self, "land", true)
        updateModuleCount(self, "both", true)

        //Max Fill Modules to all Roofs
        addModulesToAllRoofsMaxFill(self)

        //Enable Pathways to ON based on conditions
        SetPathwaysForBuildings(self, self.roofMeshArr);
    }

    UpdateSetbackDepth(self);

}
//Function to Draw Roof
export const drawRoofForGivenFace = ({ face, associatedRoofGroup, meshArr, roofMeshArr, houseId, modelType, isDrawingGroundMount, lastUsedRoofTagIndex }: DrawRoofProps) => {

    const self = useViewerStore.getState().sceneViewer;

    const {posArr, pitch, azimuth, holes, lines, flatRoof, buildingName, carport, roofFaceId} = face;

    if (!carport) {
        const floorPosArr = [];
        posArr.forEach( (item) => {
            floorPosArr.push({...item, y: 0});
        });
    }

    //Draw Roof Shape Extrude Mesh
    const {
        shapeMesh,
        lastNode,
        pos2DArr
    } = getRoofShapeMesh(posArr, pitch, azimuth, roofFaceId);

    // --------- SHADE POINT DRAWING ------------
    let holeArr: NodePos[][] = [];

    if (holes && holes.length) {
        holes.forEach(holeItem => {
            if (!holeItem.posArr || !holeItem.posArr.length) return;
            const {pos2DArr} = GetShapePosArr(holeItem.posArr, pitch, azimuth, lastNode);
            holeArr.push(pos2DArr);
        });
    }
    AddShadeMesh(shapeMesh, pos2DArr, holeArr, pitch);
    shapeMesh.rotation.x = Math.PI / 2;
    shapeMesh.receiveShadow = true;
    shapeMesh.houseId = houseId;
    shapeMesh.rotX = GetRadVal(-pitch);
    shapeMesh.rotY = GetRadVal(-azimuth);
    shapeMesh.meshType = 'roof';
    shapeMesh.posArr = posArr;
    shapeMesh.oriMap = shapeMesh.material.map;
    shapeMesh.oriColor = shapeMesh.material.color.getHex();
    shapeMesh.oriAng = face.oriAng;
    shapeMesh.flatRoof = flatRoof;
    shapeMesh.lines = lines || [];
    shapeMesh.name = 'roof'


    shapeMesh.userData.buildingName = buildingName;
    shapeMesh.userData.questionableRoof = face.questionableRoof;
    shapeMesh.userData.questionableRoofId = face.questionableRoofId;
    shapeMesh.userData.questionableRoofNotes = face.questionableRoofNotes;
    shapeMesh.userData.initialHeight = lastNode.y;
    shapeMesh.userData.roof_number_from_aurora = face.roof_number_from_aurora;
    shapeMesh.userData.pitchOverride = face.pitchOverride;
    shapeMesh.userData.originalHeight = lastNode.y;
    shapeMesh.userData.isDetachedStructure = false;


    face.roofFaceId = shapeMesh.roofFaceId
    shapeMesh.roofFaceId = face.roofFaceId;



    if (face.textureId) {
        self.setMeshTexture([shapeMesh], roofTextureList.find(t => t.alt === face.textureId)?.img, "roof", face.textureId);
    } else if (face.color) {
        self.setMeshMaterialColor([shapeMesh], face.color);
    }


    const areaInSqInches = (face.size ?? 0) * 144;
    const areaInMeters = (face.size ?? 0) / 10.764;

    shapeMesh.size = shapeMesh.userData.roof_area = face.size

    shapeMesh.sizeM = face.sizeM = areaInMeters;
    shapeMesh.sizeInSqInches = areaInSqInches;


    if (face.size && (areaInSqInches < 5200 || face.size <=50) ){
        shapeMesh.userData.roof_size_type = "small_face"
        shapeMesh.userData.roofSquare = {
            lowSquare: null,
            normalSquare: null,
        }
    }
    else{
        shapeMesh.userData.roof_size_type = "normal_face"
    }
    const data_source = sessionStorage.getItem('dataSourceOrigin');

    if(data_source === 'aurora' || data_source === 'EagleView' ){
        shapeMesh.userData.roof_tag_id = assignRoofTagId(face, shapeMesh, roofMeshArr);
    }
    else{
        shapeMesh.userData.roof_tag_id = lastUsedRoofTagIndex;
        lastUsedRoofTagIndex++;
    }

    if(flatRoof){
        shapeMesh.userData.pitchOverride = face.oriAng?.tilt;
    }

    if(!flatRoof && modelType!=="glb"){
        useViewerStore.setState({
            wallInitialHeight: shapeMesh.userData.initialHeight,
            wallEditedHeight: shapeMesh.userData.initialHeight
        })
    }



    meshArr.push(shapeMesh);
    roofMeshArr.push(shapeMesh);

    //This Group is used to azimuth the roof face
    const azimuthGroup: any = new THREE.Group();
    associatedRoofGroup.add(azimuthGroup);
    azimuthGroup.name = 'azimuthGroup';
    azimuthGroup.parentName = 'parent';
    azimuthGroup.userData.flat = flatRoof;

    //This Mesh is used to pitch the roof face
    const pitchNode = new THREE.Mesh();
    pitchNode.name = 'pitchNode';

    azimuthGroup.add(pitchNode);
    pitchNode.add(shapeMesh);

    //This rotation controls roofs orientation
    pitchNode.rotation.x = shapeMesh.rotX;
    azimuthGroup.rotation.y = shapeMesh.rotY;

    azimuthGroup.position.set(lastNode.x, lastNode.y, lastNode.z);
    azimuthGroup.worldPos = {x: lastNode.x, y:lastNode.y, z: lastNode.z};
    shapeMesh.worldPos = azimuthGroup.worldPos

    //Add Shade Positions Array to Face
    AddShadePosArr(face, shapeMesh);
}

//Function to Draw Wall
export const drawWallForGivenEdge = (edge: EdgeJson, associatedRoofGroup: RoofGroup, houseId : string | undefined, meshArr: any[]) => {

    const self = useViewerStore.getState().sceneViewer;

    const {faces} = self.roofs[0];

    const ppInfo = {h: 0, w: 0};

    //Skip Ridge
    if (edge.type === 'ridge') return;

    const isGivenFaceCarport = faces.find((face: FaceItem) => face.roofFaceId === edge.roofFaceId)?.carport;
    const carportArr = faces.filter((face: FaceItem) => face.carport === true);

    if(isGivenFaceCarport) {
        //Carport Pillars on corners
        carportArr.forEach((carport: FaceItem) => {
            const {scl, pos, posArr, azimuth} = carport;
            const pos2DArr = [
                {x: scl!.x / 2 - pillarW / 2, y: posArr[0].y, z: scl!.y / 2 - pillarW},   // Adjusted the x and z
                {x: scl!.x / 2 - pillarW / 2, y: posArr[1].y, z: -scl!.y / 2 + pillarW},  // Adjusted the x and z
                {x: -scl!.x / 2 + pillarW / 2, y: posArr[2].y, z: -scl!.y / 2 + pillarW}, // Adjusted the x and z
                {x: -scl!.x / 2 + pillarW / 2, y: posArr[3].y, z: scl!.y / 2 - pillarW}   // Adjusted the x and z
            ];
            const roofFaceId = self.roofs[0].faces.find((face: FaceItem) => face.roofFaceId === edge.roofFaceId)?.roofFaceId;
            pos2DArr.forEach(pos2D => {
                const wallOutGroup = GetPillarMesh(pos2D, pos, azimuth,self,roofFaceId,);
                associatedRoofGroup.add(wallOutGroup);
            });
        });
    }
    else {
        //Regular Walls
        const roofFaceId = self.roofs[0].faces.find((face: FaceItem) => face.roofFaceId === edge.roofFaceId)?.roofFaceId;
        const wallOutGroup = GetWallMesh(edge.posArr, houseId, meshArr, ppInfo,roofFaceId);
        associatedRoofGroup.add(wallOutGroup);
    }
}


function getRoofShapeMesh(posArr: XYZCoordinates[], pitch: number, azimuth: number, roofFaceId: string) {

    const lastNode = posArr[posArr.length - 1]
    const {pos2DArr} = GetShapePosArr(posArr, pitch, azimuth, lastNode, true);
    const testShape = GetShapeOrPath(pos2DArr) as THREE.Shape;
    const extrudeSettings = {depth: 0.1, bevelEnabled: false};
    const shapeGeo = new THREE.ExtrudeGeometry(testShape, extrudeSettings),
        shapeMat = new THREE.MeshStandardMaterial({color: defaults.ROOF_FACE_COLOR}),
        shapeMesh: any = new THREE.Mesh(shapeGeo, shapeMat);
    if(roofFaceId!==undefined) {
        shapeMesh.roofFaceId = roofFaceId

    } else {
        shapeMesh.roofFaceId = GetIdStr()
    }
    return {shapeMesh, lastNode, pos2DArr};
}


export const drawBlackBorderToRoofEdges = (self: Viewer, associatedRoofGroup: RoofGroup, roofMesh: RoofMesh) => {
    const roofPos = associatedRoofGroup.position;
    const {pos2DArr} = roofMesh, pos3DArr: NodePos[] = [];
    pos2DArr.forEach(pos2D => {
        const cloneTest = testMesh.clone();
        cloneTest.position.set(pos2D.x, pos2D.z, pos2D.y);
        roofMesh.add(cloneTest);
        const wPos = cloneTest.getWorldPosition(new THREE.Vector3());
        pos3DArr.push({...wPos});
        roofMesh.remove(cloneTest);
    });
    const posFirst= pos3DArr[0];
    pos3DArr.push(posFirst);
    const edgeMesh = GetBlackLineEdge(pos3DArr);
    edgeMesh.position.set(-roofPos.x, 0, -roofPos.z);
    edgeMesh.name = 'blackBorderMesh';
    edgeMesh.userData.roofFaceId = roofMesh.roofFaceId;
    associatedRoofGroup.add(edgeMesh);
    self.edgeMeshArr.push(edgeMesh);
};

function GetRoofLines(roofMeshArr: RoofMesh[]) {
    const roofLines: edgeLine[] = [];
    roofMeshArr.forEach(roofMesh => {
        const {posArr} = roofMesh;
        posArr.forEach((pos, idx) => {
            roofLines.push({start: pos, end: posArr[idx + 1] ?? posArr[0], posArr});
        });
    });
    return roofLines;
}

async function GetNearRoadPoint(self: Viewer, latlonStrArr: string[]) {
    const apiDataArr: NearRoadData[] = [];
    let latlong;

    for (let apiNum = 0; apiNum < latlonStrArr.length; apiNum++) {
        const latlonStr = latlonStrArr[apiNum];
        const res = await axios.get(`${import.meta.env.VITE_GOOGLE_NEAREST_ROAD_API_URL}?points=${latlonStr}&key=${import.meta.env.VITE_GOOGLE_NEAREST_ROAD_API_KEY}`);
        if (res.status !== 200 || !res.data || !res.data.snappedPoints) {
            return null;
        }

        res.data.snappedPoints.forEach((resItem: NearRoadData) => {
            apiDataArr.push({...resItem, apiPartNum: apiNum});
        });

        if (apiNum === latlonStrArr.length - 1) {
            latlong = {...res.data.snappedPoints[0].location};
        }
    }

    apiDataArr.forEach(nearRoad => {
        const {originalIndex, location, apiPartNum} = nearRoad;
        if (originalIndex === 0 && apiPartNum === 0) {
            latlong = location;
        }
    });

    return GetXYZ(self.mapCoordinates, latlong);
}

export async function LoadModelXML(self: Viewer, testRoofXml: string) {
    const sceneViewer = useViewerStore.getState().sceneViewer;
    if (sceneViewer.scene.children.length > 0) {
        sceneViewer.clearScene();
    }

    resetModuleInstances(self)

    const loadingContext = new LoadingContext();
    loadingContext.setDefaultTitle('Drawing Site...');
    loadingContext.setMessage({ message: 'Drawing Site Objects from XML...' });

    sessionStorage.setItem("dataSourceOrigin", "EagleView");

    self.designFormat = 'XML';
    self.sunInfo.utcOffset = undefined;
    self.sunInfo.timezone = undefined;

    InitStateValue(self);

    siteCalculationState.reset();

    try {
        await LoadTree(self);
        await parseXML(testRoofXml,self);
    }
    finally {
        loadingContext.dispose();
    }
}

function pitchOn12ToDegrees(pitchOn12: number) {
    return Math.atan(pitchOn12 / 12) * (180 / Math.PI);
}

function GetGroupDeltaY(group: any) {
    const pos2DArr: NodePos[] = [];
    group.children.forEach((node: any) => {
        const wPos = node.getWorldPosition(new THREE.Vector3());
        pos2DArr.push({...wPos});
    });
    const minY = Math.min(...pos2DArr.map(pos => pos.y)),
        maxY = Math.max(...pos2DArr.map(pos => pos.y));
    return maxY - minY;
}

function GetXMLPitchVal(posArr: NodePos[], azimuth: number, pitch: number) {
    const pitchVal = pitchOn12ToDegrees(pitch);
    const outGroup = new THREE.Group();
    posArr.forEach(pos => {
        const cloneTest = testMesh.clone();
        cloneTest.position.set(pos.x, pos.y, pos.z);
        cloneTest.scale.multiplyScalar(3);
        outGroup.add(cloneTest);
    });
    outGroup.rotation.set(GetRadVal(pitchVal), GetRadVal(azimuth), 0);
    if (GetGroupDeltaY(outGroup) < 0.01) return pitchVal;
    const angRange = 3, stepCount = 30, angUnit = angRange / stepCount;
    var minDeltaY = Infinity, newPitchVal = pitchVal;
    for (let i = pitchVal - angRange; i <= pitchVal + angRange; i+=angUnit) {
        outGroup.rotation.x = GetRadVal(i);
        if (GetGroupDeltaY(outGroup) < minDeltaY) {
            minDeltaY = GetGroupDeltaY(outGroup);
            newPitchVal = i;
        }
    }
    return newPitchVal;
}

async function parseXML(xml: string, self: Viewer) {
    const result = parse(xml);
    if (!result || !result.root) return;

    const location = result.root.children.find((child : any) => child.name === 'LOCATION')?.attributes;
    if (!location) return;
    const {
        lat,
        long,
        address,
        city,
        state,
        buildings
    } = location;

    self.mapCoordinates = {latitude: Number(lat), longitude: Number(long)};
    useViewerStore.setState({savedLocationCoordinates: {latitude: Number(lat), longitude: Number(long)}});

    self.sunInfo.lat = Number(lat);
    self.sunInfo.lon = Number(long);

    const stateName = state.split('-')[0].trim();


    if(isDesignOriginalSite()){
        setDetachedStructuresInStoreFromSavedBuildingData(JSON.parse(buildings));
    }

    useViewerStore.setState({ siteAddress: `${address}, ${city}, ${stateName}`});

    self.fetchMapImageAndLoadOnPlane(ImageryOptions.GOOGLE);

    const mainChild = result.root.children.find((child: any) => child.name === 'STRUCTURES');

    if (!mainChild) return;

    var minVal = Infinity;
    const roofs: BuildingJSON[] = [], obstructions: any[] = [];
    const rotation = -degToRad(parseFloat(mainChild.attributes.northorientation));
    mainChild.children.forEach((group: any) => {
        if (group.name !== 'ROOF') return;
        const nodeData = group.children.find((item: any) => item.name === 'POINTS');
        const lineData = group.children.find((item: any) => item.name === 'LINES');
        const faceData = group.children.find((item: any) => item.name === 'FACES');
        if (!nodeData || !lineData || !faceData) return;

        const nodes: NodePos[] = [], edges: EdgeJson[] = [], faces: any[] = [];
        var minPos: any = {}, maxPos: any = {};
        nodeData.children.forEach((child: any) => {
            const {attributes} = child, {id, data} = attributes, strArr = data.split(',');
            const origX = parseFloat(strArr[0]) * 0.33,
                y = parseFloat(strArr[2]) * 0.33,
                origZ = parseFloat(strArr[1]) * -0.33;

            const x = origX * Math.cos(rotation) + origZ * Math.cos(rotation + (Math.PI / 2));
            const z = origX * Math.sin(rotation) + origZ * Math.sin(rotation + (Math.PI / 2));

            if (minPos.x === undefined) {
                minPos = {x, y, z};
                maxPos = {x, y, z};
            } else {
                if (minPos.x > x) minPos.x = x; else if (maxPos.x < x) maxPos.x = x;
                if (minPos.y > y) minPos.y = y; else if (maxPos.y < y) maxPos.y = y;
                if (minPos.z > z) minPos.z = z; else if (maxPos.z < z) maxPos.z = z;
            }
            nodes.push({id, x, y, z});
        });
        const deltaPos = {
            x: (minPos.x + maxPos.x) / -2,
            y: 0,
            z: (minPos.z + maxPos.z) / -2
        }
        if (minPos.y < 3) deltaPos.y = 3 - minPos.y;
        minVal = Math.max(3, minPos.y);
        nodes.forEach(item => {
            item.x += deltaPos.x;
            item.y += deltaPos.y;
            item.z += deltaPos.z;
            item.oldY = item.y;
        });
        lineData.children.forEach((child: any) => {
            const {id, path, type} = child.attributes, strArr: string[] = path.split(',');
            var lineItem: EdgeJson = {id, type: type.toLowerCase(), posArr: []}
            strArr.forEach(nodeId => {
                const node = nodes.find(item => item.id === nodeId);
                if (node) lineItem.posArr.push(node);
            });
            edges.push(lineItem);
        });

        faceData.children.forEach((child: any) => {
            const {type} = child.attributes;
            const {id, path, orientation, pitch, size, roof_number} = child.children[0].attributes,
                strArr = path.split(',');

            //check if roof_number attribute is missing
            if(roof_number === undefined || roof_number === null || roof_number === ''){
                throw new Error("Roof Number attribute is missing in the XML file. Please validate the XML file and try again.");

            }


            const posArr = GetXMLFacePosArr(edges, strArr);
            if (type === 'ROOF') {
                const azimuth = parseFloat(orientation),
                    pitchVal = GetXMLPitchVal(posArr, azimuth, parseFloat(pitch)),
                    irrDir = {tilt: pitchVal, azimuth};
                faces.push({
                    id,
                    posArr,
                    pitch: pitchVal,
                    azimuth,
                    size: Number(size),
                    holes: [],
                    irrDir,
                    oriAng: {azimuth, tilt: pitchVal},
                    roof_number_from_aurora: Number(roof_number)
                });
            } else if (type === 'ROOFPENETRATION') {
                obstructions.push({
                    normal_top: {X: 0.5, Y: 0.5, Z: 1},
                    nodes: [...posArr],
                    radius: 0,
                    type: 'polygon',
                });
            }
        });
        roofs.push({nodes, edges, faces});
    });

    self.roofs = roofs;
    self.wallHEdit = minVal;


    SetTerrain(self, self.mapCoordinates);
    await drawDesign(self, false, undefined, obstructions);
    await GetTimeZone(self);
    ModelLoadInit(self);
    DeleteSingleModuleOnRoof(self);
    self.ifContainsFlatRoofAndEnableBallastedRacking()
    syncSetbackVisibilityForDetachedBuildings()
    self.hideObject(HideObjectType.GhostObst, true);
    registerCalculations(self);

    siteCalculationState.needsUpdate(ACCESS_MULTIPLIERS, 0);
    siteCalculationState.useCalculations(ACCESS_MULTIPLIERS);

    sleep(1000).then(async () => {
        // renderer does not fully load if document is not in focus, causing shade calculations to be incorrect
        // rerun shade calculations if document was not focused

        const focused = document.hasFocus();
        while (!document.hasFocus()) {
            await sleep(250);
        }

        if (!focused) {
            siteCalculationState.needsUpdate(SHADE_CALCULATIONS);
        }

        // await siteCalculationState.useCalculations(SHADE_CALCULATIONS);
    });



    // useViewerStore.setState({loadingCompleted: true})
}

export function LoadStreetView(self: Viewer) {
    if (self.mapCoordinates.latitude === null && self.mapCoordinates.longitude === null) return;

    let streetViewContainer = document.getElementById("google-street-view-container") as HTMLDivElement;
    streetViewContainer.classList.remove('no-pointer-events');


    let streetViewIframe = document.querySelector(".street-view-iframe") as HTMLIFrameElement;
    let heading = 360 - self.compassHeading
    streetViewIframe.src = `${import.meta.env.VITE_GOOGLE_STREET_VIEW_API_URL}?key=${import.meta.env.VITE_GOOGLE_STREET_VIEW_API_KEY}&location=${self.mapCoordinates.latitude},${self.mapCoordinates.longitude}&heading=${heading}&pitch=10`;

    let canvasContainer = document.getElementById('canvasContainer') as HTMLDivElement;


    if(canvasContainer.classList.contains('canvas-expanded')) {
        canvasContainer.classList.remove('canvas-expanded')
    }
    if(canvasContainer.classList.contains('canvas-collapsed')) {
        canvasContainer.classList.remove('canvas-collapsed')
    }
    if (!canvasContainer.classList.contains('canvas-street-view-split')) {
        canvasContainer.classList.add('canvas-street-view-split')
    }


    self.isViewerInSplitMode = true;

    self.cSize.w = window.innerWidth / 2;

    self.resizeCanvas()

    streetViewContainer.appendChild(streetViewIframe);
    streetViewContainer.style.display = "block";
}

export function SetPathwaysForBuildings(self: Viewer, roofMeshArr: RoofMesh[]) {
    const minPathwayCountPerBuilding = 2;
    const minPathwayCountBuildingRear = 1;

    const roofsByBuilding: { [buildingName: number]: RoofMesh[] } = {};
    const accessoryBuildingList = useViewerStore.getState().accessoryBuildingList;

    roofMeshArr.forEach(roofMesh => {
        const buildingName = roofMesh.userData.buildingName;
        if (accessoryBuildingList.includes(buildingName.toString())) return;

        if (!roofsByBuilding[buildingName]) {
            roofsByBuilding[buildingName] = [];
        }

        roofsByBuilding[buildingName].push(roofMesh);
    });

    const isVectorBetween = (a: THREE.Vector3, b: THREE.Vector3, x: THREE.Vector3) => {
        const line = a.clone().sub(b);
        const projected = x.clone().sub(b).projectOnVector(line).add(b);

        return Math.abs(a.distanceTo(projected) + b.distanceTo(projected) - line.length()) < 1;
    };

    let nearPoint: THREE.Vector3 | null = null;
    if (self.roadNearPoint) {
        nearPoint = new THREE.Vector3(self.roadNearPoint.x, self.roadNearPoint.y, self.roadNearPoint.z);
    }

    // for each building
    Object.keys(roofsByBuilding).forEach((buildingName) => {
        const roofs = roofsByBuilding[Number(buildingName)];
        const roofsByHeight: { [height: number]: RoofMesh[] } = {};
        const roofMeta: { [roofFaceId: string]: RoofMeta } = {};
        let pathwaysSet = 0;
        let rearPathwaysSet = 0;

        const buildingCenter = GetBuildingCenter(roofMeshArr, Number(buildingName));

        // roof data setup
        for (const roof of roofs) {
            const height = GetRoofHeight(roof);

            let added = false;
            for (const otherHeight of Object.keys(roofsByHeight)) {
                // check if heights are similar
                if (Math.abs(height - Number(otherHeight)) < 0.05) {
                    roofsByHeight[Number(otherHeight)].push(roof);
                    added = true;
                    break;
                }
            }

            const roofCenter = GetRoofCenter(roof);

            roofMeta[roof.roofFaceId] = {
                center: roofCenter,
                isFront: !nearPoint || isVectorBetween(buildingCenter, nearPoint, roofCenter),
                distanceToRoad: nearPoint ? roofCenter.distanceTo(nearPoint) : null,
            };

            if (!added) {
                roofsByHeight[height] = [roof];
            }
        }

        const setIdealPathway = (roof: RoofMesh) => {
            const pathway = GetRoofIdealPathway(roof);
            if (!pathway) return;

            SetPathwayValue(self, pathway.pathwayId, true);
            pathwaysSet++;

            if (!roofMeta[roof.roofFaceId].isFront) {
                rearPathwaysSet++;
            }
            return pathway;
        };

        // for each roof level
        for (const height of Object.keys(roofsByHeight)) {
            const roofs = roofsByHeight[Number(height)];
            let selectedRoof = roofs[0];

            if (nearPoint && roofs.length > 1) {
                selectedRoof = [...roofs].sort((a, b) => {
                    const aMeta = roofMeta[a.roofFaceId];
                    const bMeta = roofMeta[b.roofFaceId];

                    if (!aMeta.isFront && !bMeta.isFront) {
                        return b.size - a.size;
                    }

                    if (aMeta.isFront && !bMeta.isFront) {
                        return -1;
                    }

                    if (!aMeta.isFront && bMeta.isFront) {
                        return 1;
                    }

                    if (aMeta.distanceToRoad === null || bMeta.distanceToRoad === null) {
                        return 0;
                    }
                    return aMeta.distanceToRoad - bMeta.distanceToRoad;
                })[0];
            } else {
                selectedRoof = roofs[0];
            }

            setIdealPathway(selectedRoof);
        }

        if (pathwaysSet < minPathwayCountPerBuilding) {
            // if the pathways set is below minimum
            const roofsSorted = [...roofs].sort((a, b) => b.size - a.size);

            for (let idx = 0; idx < roofsSorted.length && pathwaysSet < minPathwayCountPerBuilding; idx++) {
                const roof = roofsSorted[idx];
                if (!RoofHasPathwaySelected(roof)) {
                    setIdealPathway(roof);
                }
            }
        }

        if (rearPathwaysSet < minPathwayCountBuildingRear) {
            // if the rear pathways set is below minimum
            const roofsSorted = roofs.filter(r => !roofMeta[r.roofFaceId].isFront).sort((a, b) => b.size - a.size);

            for (let idx = 0; idx < roofsSorted.length && rearPathwaysSet < minPathwayCountBuildingRear; idx++) {
                const roof = roofsSorted[idx];
                if (!RoofHasPathwaySelected(roof)) {
                    setIdealPathway(roof);
                }
            }
        }
    });
}

function GetRoofCenter(roofMesh: RoofMesh) {
    const roofCenter = new THREE.Vector3();

    const posArr = roofMesh.geometry.attributes.position.array;
    for (let i = 0; i < posArr.length; i += 3) {
        roofCenter.x += posArr[i];
        roofCenter.y += posArr[i + 1];
        roofCenter.z += posArr[i + 2];
    }

    roofCenter.divideScalar(posArr.length / 3);
    roofCenter.applyMatrix4(roofMesh.matrixWorld);
    return roofCenter;
}

function GetBuildingCenter(roofMeshArr: RoofMesh[], buildingName: number) {
    const center = new THREE.Vector3();
    let roofCount = 0;

    for (const roof of roofMeshArr) {
        if (roof.userData.buildingName?.toString() === buildingName.toString()) {
            center.add(GetRoofCenter(roof));
            roofCount++;
        }
    }

    if (roofCount > 0) {
        center.divideScalar(roofCount);
    }

    return center;
}

function GetRoofNodes(roofMesh: RoofMesh) {
    const nodes = [];
    const posArr = roofMesh.geometry.attributes.position.array;

    for (let i = 0; i < posArr.length; i += 3) {
        nodes.push(new THREE.Vector3(posArr[i], posArr[i + 1], posArr[i + 2]).applyMatrix4(roofMesh.matrixWorld));
    }

    return nodes;
}

function GetRoofHeight(roofMesh: RoofMesh) {
    let maxHeight = 0;
    for (const node of GetRoofNodes(roofMesh)) {
        if (node.y > maxHeight) {
            maxHeight = node.y;
        }
    }

    return maxHeight;
}

function GetRoofIdealPathway(roofMesh: RoofMesh) {
    const pathwayMeshes = roofMesh.children.filter((child: any) => child.pathwayId) as PathwayMesh[];

    if (pathwayMeshes.length === 0) {
        return undefined;
    }

    const biggestPathway = pathwayMeshes.reduce((prev, current) => {
        return prev.size > current.size ? prev : current
    });

    return biggestPathway;
}

function RoofHasPathwaySelected(roofMesh: RoofMesh) {
    return roofMesh.children.some((child: any) => child.pathwayId && child.pathActive);
}

const setDetachedStructuresInStoreFromSavedBuildingData = (buildingDataFromJSON: BuildingDataJSON[])=>{

    const detachedStructureBuildingIds = buildingDataFromJSON
        .filter(building => building?.isDetachedStructure)
        .map(building => Number(building.name));

    useViewerStore.setState({detachedStructureBuildingIds});
}